/**
 * Created by luoyinxian on 2/9/17.
 */
import URI from 'urijs';
import React from 'react';
import { isset, fetchApi } from 'utils';
import { NUMBER_TYPE, SORTTYPES } from 'constants';
import { PopUp, ModalDialog } from 'components';
import { printFaultCorrect } from './printFaultTip';
import { dataFormatBatch } from '../../utilcomponents/tableV2/helper/dataFormater';
import { downloadPDF } from '../../../utils/downloadFile';
import { printStatusCommand, PRINT_TYPE } from './printUtils';
const { specialFieldConf, maxWidthConf, stretchConf } = require('./specialFieldConf');

function getPrefixAndId(currId) {
  let tmpId = currId;
  const currPrefix = 'lodopCustomVars.';
  const reg = /order(\d*)\./;
  const pStationReg = /p_station(\d*)\./;
  const feeApprovalReg = /fee_approval(\d*)\./;
  const approvalReg = /approval(\d*)\./;
  const feeApprovalAggReg = /fee_approval_agg(\d*)\./;
  const drivertrNumReg = /driver_tr_num(\d*)\./;
  const payModeReg = /pay_mode(\d*)\./;
  if (reg.test(tmpId)) {
    const elemKey = tmpId.split('.');
    const regVal = RegExp.$1;
    elemKey.splice(0, 1);
    const suffix = elemKey.join('.');
    tmpId = `order${regVal}[0].${suffix}`;
  } else if (pStationReg.test(tmpId)) {
    const elemKey = tmpId.split('.');
    const regVal = RegExp.$1;
    elemKey.splice(0, 1);
    const suffix = elemKey.join('.');
    tmpId = `p_station${regVal}[0].${suffix}`;
  } else if (feeApprovalReg.test(tmpId)) {
    const elemKey = tmpId.split('.');
    const regVal = RegExp.$1;
    elemKey.splice(0, 1);
    const suffix = elemKey.join('.');
    tmpId = `fee_approval${regVal}[0].${suffix}`;
  } else if (approvalReg.test(tmpId)) {
    const elemKey = tmpId.split('.');
    const regVal = RegExp.$1;
    elemKey.splice(0, 1);
    const suffix = elemKey.join('.');
    tmpId = `approval${regVal}[0].${suffix}`;
  } else if (feeApprovalAggReg.test(tmpId)) {
    const elemKey = tmpId.split('.');
    const regVal = RegExp.$1;
    elemKey.splice(0, 1);
    const suffix = elemKey.join('.');
    tmpId = `fee_approval_agg${regVal}[0].${suffix}`;
  } else if (drivertrNumReg.test(tmpId)) {
    const elemKey = tmpId.split('.');
    const regVal = RegExp.$1;
    elemKey.splice(0, 1);
    const suffix = elemKey.join('.');
    tmpId = `driver_tr_num${regVal}[0].${suffix}`;
  } else if (payModeReg.test(tmpId)) {
    const elemKey = tmpId.split('.');
    const regVal = RegExp.$1;
    elemKey.splice(0, 1);
    const suffix = elemKey.join('.');
    tmpId = `pay_mode${regVal}[0].${suffix}`;
  }
  return {
    prefix: currPrefix,
    id: tmpId,
  };
}

function getTdData(itemKey, oriVal, flex_type) {
  let newTdVal = oriVal;
  if (flex_type !== 'complex') {
    return newTdVal;
  }
  // 发货人手机、收货人手机遇到 空格、斜杠、反斜杠 就换行
  const brFields = ['cor_mobile', 'cee_mobile'];
  if (brFields.includes(itemKey)) {
    newTdVal = newTdVal.trim();
    const needBr = newTdVal.includes(' ') || newTdVal.includes('/') || newTdVal.includes('\\');
    if (needBr) {
      newTdVal = newTdVal.replace(/[\s/\\]+/g, '<br/>');
    }
  }
  return newTdVal;
}

function deleteSpecialStr(str) {
  const newStr = str.replace(/[\n|\r\n|\r|\\]/g, ''); // 反斜线会导致解析错误
  return newStr.replace(/"/g, '\\"');
}

// 处理数据中有换行的情况-批次信息
function tmpSpecialData(data, type) {
  const confList = specialFieldConf[type];
  if (!confList) return data;
  const newData = Object.assign({}, data);
  confList.forEach(key => {
    // eslint-disable-next-line no-unused-expressions
    newData[key] ? (newData[key] = data[key] && deleteSpecialStr(data[key])) : '';
  });
  return newData;
}

/**
 * 数据拆分
 * 原因：按照货物行显示运单（打印模板增加了此设置项）
 *       如果用户勾选了此设置，则如果运单是多货运单则一行货物显示一行数据。
 *        （1）其中以下字段分行显示：货物名称、包装、包装服务、件数、托数、单件重量、重量、重量单价、体积、体积单价、单价、运费小计、货物类型、规格、型号、特殊货物
 *        （2）其余字段（如：现付）还是每行显示这个运单的该字段的值即可。
 */
function dataSplit(data, printSetting) {
  let newData = [];
  if (printSetting.multi_goods) {
    data.forEach(item => {
      let itemArr = [];
      const curItem = Object.assign({}, item);

      const goodsVal = curItem.goods;
      if (goodsVal && Array.isArray(goodsVal) && goodsVal.length > 1) {
        const keyArr = [
          'g_cat',
          'g_model',
          'g_n',
          'g_name',
          'g_pkg',
          // 'g_pkg_service',  46454
          'g_pkg_service_disp',
          'g_price_unit',
          'g_shaped',
          'g_spec',
          'g_special',
          'g_subtotal_price',
          'g_tray_count',
          'g_unit_price_disp',
          'g_volume',
          'g_volume_unit_price',
          'g_weight',
          'g_weight_per_num',
          'g_weight_unit_price',
          'b_tr_load_n',
          'b_tr_load_v',
          'b_tr_load_w',
        ];
        for (let i = 0, l = goodsVal.length; i < l; i++) {
          const cItem = Object.assign({}, curItem);
          keyArr.forEach(cK => {
            if (cK.includes('b_tr_load')) {
              cItem[cK] = cItem[cK] && curItem[cK][i];
            } else {
              cItem[cK] = cItem[cK] && curItem.goods[i][cK];
            }
          });
          itemArr.push(cItem);
        }
      } else {
        itemArr = [...itemArr, curItem];
      }

      newData = [...newData, ...itemArr];
    });
  } else {
    newData = [...data];
  }

  return newData;
}

// 处理数据中有换行的情况-运单，运单结构是数组中带数组
function tmpOrderSpecialData(data, flex_type) {
  if (data.length < 1) return data;
  const newData = [...[], ...data];
  data.forEach((item, index) => {
    const newItem = item;
    Object.keys(newItem).forEach(itemKey => {
      const itemValue = getTdData(itemKey, item[itemKey], flex_type);
      if (itemValue && Array.isArray(itemValue) && itemValue.length > 0) {
        // 数组 如货物['货物1', '货物2']
        let itemNewValue = itemValue.join(',,--,,');
        itemNewValue = deleteSpecialStr(itemNewValue);
        itemNewValue = itemNewValue.split(',,--,,');
        newItem[itemKey] = itemNewValue;
      }
      if (itemValue && typeof itemValue === 'string') {
        // 字符串
        newItem[itemKey] = deleteSpecialStr(itemValue);
      }
    });
    newData[index] = newItem;
  });
  return newData;
}

// 打印时按拼音首字母排序
function pingyiSort(proxy) {
  const { data, set } = proxy;
  const sortData = [...data];
  const { order_header, /* category, */ type, print_sort, print_group, sum_display, pinyin_sort } = set;

  // const pingyiSortGID = ['319', '71317']
  // if (!pingyiSortGID.includes(window.group_id)) {
  //   return data
  // }

  if (!pinyin_sort) {
    return data;
  }

  const pingyiSortTpl = ['tr_loading_list'];
  if (!pingyiSortTpl.includes(type)) {
    return data;
  }

  // if (+category !== 0) { // 只支持自定义非套打
  //   return data
  // }

  if (Array.isArray(print_sort) && !print_sort.length) {
    // 未设置排序规则
    return data;
  }

  // 有的合计设置，后端返回的数据中包含合计行信息
  const oriLength = data.length;
  const slice1Val = ['display', 'non-display'].includes(sum_display) && !data[oriLength - 1].id;
  const slice2Val =
    sum_display === 'group-display' && Array.isArray(print_group) && print_group.length && !data[oriLength - 2].id;
  // eslint-disable-next-line no-nested-ternary
  const sliceLength = slice1Val ? -1 : slice2Val ? -2 : 0;
  const sumRowData = sortData.splice(sliceLength);

  let sortIdx = 1;
  const sortFields = [];
  const sortFieldsMap = {};
  print_sort.forEach(field => {
    const isDesc = field.includes('_desc') && !field.split('_desc')[1];
    const key = field.slice(0, isDesc ? -5 : -4);
    sortFields.push(key);
    sortFieldsMap[key] = isDesc ? 'desc' : 'asc';
  });
  const subCompareSort = subProxy => {
    const { key, xVal, yVal } = subProxy;
    const headerCol = order_header[key];
    const colType = headerCol.type;

    let sortVal = 0;
    const numberX = Number(xVal);
    const numberY = Number(yVal);
    if (NUMBER_TYPE.includes(colType) && !Number.isNaN(numberX) && !Number.isNaN(numberY)) {
      if (numberX > numberY) {
        sortVal = 1;
      }
      if (numberX < numberY) {
        sortVal = -1;
      }
    } else {
      sortVal = xVal.localeCompare(yVal, 'zh');
    }

    if (sortFieldsMap[key] === SORTTYPES.DESC) {
      sortVal *= -1;
    }
    return sortVal;
  };
  const basicSort = (rowx, rowy) => {
    let sortVal = 0;
    for (let ind = 0; ind < sortFields.length; ind++) {
      const key = sortFields[ind];
      if (!rowx[key] || !rowy[key]) {
        sortVal = 1;
      } else {
        sortVal = subCompareSort({ key, xVal: rowx[key], yVal: rowy[key] });
      }
      if (sortVal !== 0) break;
    }
    return sortVal;
  };
  sortData.sort(basicSort);
  sortData.forEach(row => {
    if (row.id) {
      row.id = sortIdx; // eslint-disable-line
      sortIdx += 1;
    }
  });

  // console.log('=== pingyiSort ===', set, order_header, sumRowData)
  return [...sortData, ...sumRowData];
}

function approvalSpecialData(data) {
  if (data.length < 1) return data;
  const newData = [...[], ...data];
  data.forEach((item, index) => {
    const newItem = { ...item };
    newData[index] = tmpSpecialData(newItem, 'approval');
  });
  return newData;
}

function parsePrintData(data, printSetting) {
  const tmpData = data;
  if (!tmpData) {
    return;
  }
  window.lodopCustomVars = window.lodopCustomVars || {};
  const noThousandSep = isset(window.psn_setting, 'skin_set.__meta.thousandSep', '1') === '2';
  const formatExt = { exceptKeys: noThousandSep ? ['thousands_sep'] : undefined };
  if (tmpData.batch) {
    delete window.lodopCustomVars.batch;
    // 格式化批次数据
    if (printSetting.batch_header) {
      tmpData.batch = dataFormatBatch(
        [tmpSpecialData(tmpData.batch, 'batch')],
        printSetting.batch_header,
        formatExt,
      )[0];
    } else {
      tmpData.batch = tmpSpecialData(tmpData.batch, 'batch');
    }
  }
  if (tmpData.approval) {
    delete window.lodopCustomVars.approval;
    tmpData.approval = approvalSpecialData(tmpData.approval, 'approval');
  }

  if (tmpData.order) {
    delete window.lodopCustomVars.order;
    const orderData = dataSplit(tmpData.order, printSetting);
    // 格式化运单数据
    if (printSetting.order_header) {
      tmpData.order = dataFormatBatch(
        tmpOrderSpecialData(orderData, printSetting.flex_type),
        printSetting.order_header,
        formatExt,
      );
    } else {
      tmpData.order = tmpOrderSpecialData(orderData, printSetting.flex_type);
    }
    const sortedOrderData = pingyiSort({ data: tmpData.order, set: printSetting });
    tmpData.order = sortedOrderData;
  } else {
    tmpData.order = [];
  }
  if (tmpData.user) {
    delete window.lodopCustomVars.user;
  }
  window.lodopCustomVars = tmpData;
}

function sleep(ms) {
  return new Promise(resolve => setTimeout(resolve, ms));
}

const isPreview = proxy => {
  const { dataSum, printSetting = {} } = proxy;
  const { type, pop_preview } = printSetting;
  const needPreviewTpl = [
    'order',
    'envelope',
    'tr_loading_list',
    'delivery_loading_list',
    'pickup_loading_list',
    'customer_bill_detail',
    'order_pay_rec_bill_detail',
    'pickup_pay_rec_bill_detail',
    'delivery_pay_rec_bill_detail',
    'shuttle_pay_rec_bill_detail',
    'tr_pay_rec_bill_detail',
  ];
  const single = +dataSum === 1;
  if (single && needPreviewTpl.includes(type) && pop_preview) {
    return true;
  }
  return false;
};

// printSetting 必须包含打印机名称
export function printWait(LODOP, needCheck, printSetting) {
  console.log('printWaitV1 ---> printWait');
  // eslint-disable-next-line no-async-promise-executor
  return new Promise(async resolve => {
    if (!LODOP) {
      resolve(3); // Lodop本地应用 在进入系统之前就未启动或已停止， 完全需要重启
      return;
    }
    if (!LODOP.webskt || LODOP.webskt.readyState !== 1) {
      resolve(2);
    } else {
      resolve(1);
    }
  });
}

function printLog(data, setting, printNum) {
  if (!window.company_setting.order_info_show_print_log.checked) return;
  const odLinkId = Array.isArray(data) ? data.map(item => item.od_link_id) : [data.od_link_id];
  const req = {
    od_link_ids: odLinkId,
    tpl_id: setting.tpl_id,
    tpl_name: setting.tpl_name,
    tpl_type: setting.type,
    refer: 'pc',
    print_num: printNum,
  };

  if ([266, 349, 69341].includes(+window.group_id) && !Array.isArray(data)) {
    req.debug_info = window[`lodopCustomVarsPrint_${data.order_num}`];
  }

  if (!odLinkId[0]) return;
  fetchApi('/Basic/Print/addPrintLog', { method: 'POST', body: { req } });
}

export function genQrCode(LODOP, value) {
  const prefixId = getPrefixAndId(value);
  const { prefix } = prefixId;
  const { id } = prefixId;
  const systemVar = `LODOP.ADD_PRINT_BARCODEA("${id}", 9, 201, 145, 70, "QRCode", lodopCustomVars.${id});
    LODOP.SET_PRINT_STYLEA(0, "QRCodeErrorLevel", "M");
    LODOP.SET_PRINT_STYLEA(0, "ContentVName", "${prefix}${id}");`;
  eval(systemVar); // eslint-disable-line no-eval
  // LODOP.SET_SHOW_MODE('DESIGN_IN_BROWSER', 1)
  // LODOP.PRINT_DESIGN()
  return systemVar;
}

export function genBarCode(LODOP, value) {
  const prefixId = getPrefixAndId(value);
  const { prefix } = prefixId;
  const { id } = prefixId;
  const systemVar = `LODOP.ADD_PRINT_BARCODEA("${id}", 9, 201, 145, 70, "128Auto", lodopCustomVars.${id});
    LODOP.SET_PRINT_STYLEA(0, "QRCodeErrorLevel", "M");
    LODOP.SET_PRINT_STYLEA(0, "ContentVName", "${prefix}${id}");`;
  eval(systemVar); // eslint-disable-line no-eval
  // LODOP.SET_SHOW_MODE('DESIGN_IN_BROWSER', 1)
  // LODOP.PRINT_DESIGN()
  return systemVar;
}

export function genText(LODOP, value) {
  const prefixId = getPrefixAndId(value);
  const { prefix } = prefixId;
  const { id } = prefixId;
  const systemVar = `LODOP.ADD_PRINT_TEXTA("${value}", 9, 201, 186, 25, lodopCustomVars.${id});
    LODOP.SET_PRINT_STYLEA(0, "FontSize", 11);
    LODOP.SET_PRINT_STYLEA(0, "ContentVName", "${prefix}${id}");`;
  eval(systemVar); // eslint-disable-line no-eval
  // LODOP.SET_SHOW_MODE('DESIGN_IN_BROWSER', 1)
  // LODOP.PRINT_DESIGN()
  return systemVar;
}

export function genUrl(LODOP, value) {
  window.lodopCustomVars = window.lodopCustomVars || {};
  const prefixId = getPrefixAndId(value);
  const { prefix } = prefixId;
  const { id } = prefixId;
  window.lodopCustomVars[id] = `<img border="0" src="">${value}</img>`;
  const systemVar = `LODOP.ADD_PRINT_IMAGE(9, 201, 186, 25, lodopCustomVars.${id});
    LODOP.SET_PRINT_STYLEA(0, "Stretch", 1);
    LODOP.SET_PRINT_STYLEA(0, "ContentVName", "${prefix}${id}");`;
  eval(systemVar); // eslint-disable-line no-eval
  return systemVar;
}

export function printPreview(LODOP, data) {
  parsePrintData(data, {});
  eval(LODOP.GET_VALUE('ProgramCodes', 0)); // eslint-disable-line no-eval
  LODOP?.SET_SHOW_MODE?.('DESIGN_IN_BROWSER', 1);
  LODOP.SET_PRINT_MODE('PROGRAM_CONTENT_BYVAR', true);
  LODOP.PRINT_DESIGN();
}

function parsePrintSetting(LODOP, printSetting, newTplStrParam) {
  const marginLeft = printSetting.margin_left || 0;
  const marginTop = printSetting.margin_top || 0;
  const direction = printSetting.direction || 'horizontal';
  let newTplStr = newTplStrParam;
  let printHeight = printSetting.height;
  let printWidth = printSetting.width;
  let pageDirection = 1;
  if (direction === 'horizontal') {
    pageDirection = 2;
  } else if (printSetting.print_rotate && printSetting.print_rotate === 'rotate') {
    const tplArr = newTplStr.split(');');
    const newTplArr = [];
    for (const tplStatement of tplArr) {
      newTplArr.push(tplStatement);
      if (
        (tplStatement.indexOf('ADD_PRINT_TEXT') !== false && tplStatement.indexOf('ADD_PRINT_TEXT') >= 0) ||
        (tplStatement.indexOf('ADD_PRINT_BARCODEA') !== false && tplStatement.indexOf('ADD_PRINT_BARCODEA') >= 0) ||
        (tplStatement.indexOf('ADD_PRINT_IMAGE') !== false && tplStatement.indexOf('ADD_PRINT_IMAGE') >= 0) ||
        (tplStatement.indexOf('ADD_PRINT_HTM') !== false && tplStatement.indexOf('ADD_PRINT_HTM') >= 0)
      ) {
        newTplArr.push('LODOP.SET_PRINT_STYLEA(0, "AngleOfPageInside", 270');
      }
      newTplStr = newTplArr.join(');');
    }
    const tmp = printHeight;
    printHeight = printWidth;
    printWidth = tmp;
  }
  LODOP.PRINT_INITA(`${marginTop}mm`, `${marginLeft}mm`, `${printHeight}mm`, `${printWidth}mm`, '自定义打印模板');
  LODOP.SET_PRINT_PAGESIZE(pageDirection, `${printHeight}mm`, `${printWidth}mm`, '');
  return newTplStr;
}

function parseTablePrintSetting(LODOP, printSetting, newTplStrParam) {
  const marginLeft = printSetting.margin_left || 0;
  const marginTop = printSetting.margin_top || 0;
  const direction = printSetting.direction || 'horizontal';
  let newTplStr = newTplStrParam;
  let printHeight = printSetting.height;
  let printWidth = printSetting.width;
  let pageDirection = 1;
  if (direction === 'horizontal') {
    pageDirection = 2;
  }
  if (printSetting.print_rotate && printSetting.print_rotate === 'rotate') {
    const tplArr = newTplStr.split(');');
    const newTplArr = [];
    for (const tplStatement of tplArr) {
      newTplArr.push(tplStatement);
      if (
        (tplStatement.indexOf('ADD_PRINT_TEXT') !== false && tplStatement.indexOf('ADD_PRINT_TEXT') >= 0) ||
        (tplStatement.indexOf('ADD_PRINT_BARCODEA') !== false && tplStatement.indexOf('ADD_PRINT_BARCODEA') >= 0) ||
        (tplStatement.indexOf('ADD_PRINT_IMAGE') !== false && tplStatement.indexOf('ADD_PRINT_IMAGE') >= 0) ||
        (tplStatement.indexOf('ADD_PRINT_TABLE') !== false && tplStatement.indexOf('ADD_PRINT_TABLE') >= 0) ||
        (tplStatement.indexOf('ADD_PRINT_HTM') !== false && tplStatement.indexOf('ADD_PRINT_HTM') >= 0)
      ) {
        newTplArr.push('LODOP.SET_PRINT_STYLEA(0, "AngleOfPageInside", 270');
      }
      newTplStr = newTplArr.join(');');
    }
    const tmp = printHeight;
    printHeight = printWidth;
    printWidth = tmp;
    pageDirection = 1;
  }
  if (direction === 'horizontal' && printSetting.print_rotate && printSetting.print_rotate !== 'rotate') {
    LODOP.PRINT_INITA(`${marginTop}mm`, `${marginLeft}mm`, `${printWidth}mm`, `${printHeight}mm`, '自定义打印模板');
    printSetting.paper && printSetting.paper === 'custom'
      ? LODOP.SET_PRINT_PAGESIZE(pageDirection, `${printWidth}mm`, `${printHeight}mm`, '')
      : LODOP.SET_PRINT_PAGESIZE(pageDirection, 0, 0, printSetting.paper);
    LODOP?.SET_SHOW_MODE?.('LANDSCAPE_DEFROTATED', 1);
  } else {
    LODOP.PRINT_INITA(`${marginTop}mm`, `${marginLeft}mm`, `${printHeight}mm`, `${printWidth}mm`, '自定义打印模板');
    if (printSetting.paper && printSetting.paper === 'custom') {
      LODOP.SET_PRINT_PAGESIZE(pageDirection, `${printHeight}mm`, `${printWidth}mm`, '');
      if (printSetting.type === 'tr_loading_list' && printSetting.flex_type === 'complex') {
        // 之所以保留上面错误的打印指令，是因为线上已经有好多这样的模版（多列标签）
        LODOP.SET_PRINT_PAGESIZE(pageDirection, `${printWidth}mm`, `${printHeight}mm`, '');
      }
    } else {
      LODOP.SET_PRINT_PAGESIZE(pageDirection, 0, 0, printSetting.paper);
    }
  }
  return newTplStr;
}

export async function printPrepare(LODOP, data, printSetting, tplStr, needCheck, isRetry) {
  !needCheck && !isRetry && (window.PRINTERRORSTEP = 1);

  const checkResult = await printWait(LODOP, needCheck, printSetting);
  console.log('print --->  checkResult', checkResult);
  if (checkResult !== 1) {
    const correctResult = await printFaultCorrect(checkResult, printSetting);
    const printSettingNext = typeof correctResult === 'object' ? { ...printSetting, ...correctResult } : printSetting;
    correctResult && (await printPrepare(window.globalLodopObj, data, printSettingNext, tplStr, false, true));
    return;
  }

  parsePrintData(data, printSetting);
  let newTplStr = tplStr;
  if (printSetting && printSetting.width && printSetting.height) {
    newTplStr = parsePrintSetting(LODOP, printSetting, newTplStr);
  }
  // jsscript改为处理数据脚本 2022-12-14
  // if (printSetting.jsscript) {
  //   newTplStr = eval(printSetting.jsscript); // eslint-disable-line no-eval
  // }

  if ([266, 349, 69341].includes(+window.group_id) && !Array.isArray(data)) {
    window[`lodopCustomVarsPrint_${data.order_num}`] = { eval_order_num: window.lodopCustomVars.order_num };
  }

  eval(newTplStr); // eslint-disable-line no-eval
  LODOP.SET_PRINT_MODE('PROGRAM_CONTENT_BYVAR', true);

  // bug 44106 start  custom_order  print_copies  printCopies
  let printCopies = printSetting.printCopies || 1;
  if (printSetting.type === 'custom_order') {
    printCopies = printSetting.print_copies || printCopies;
  }
  // bug 44106 end

  // 如果选择了打印机，需要重新设置打印机，否则使用默认的打印机
  LODOP.SET_PRINT_COPIES(printCopies);
  if (printSetting && printSetting.printer) {
    const printerCount = LODOP.GET_PRINTER_COUNT();
    for (let i = 0; i < printerCount; ++i) {
      const printerName = LODOP.GET_PRINTER_NAME(i);
      if (printerName === printSetting.printer) {
        LODOP.SET_PRINTER_INDEXA(printerName);
      }
    }
  }
}

export async function print(proxy) {
  const { LODOP, data, printSetting, tplStr, needCheck, dataSum = 1 } = proxy;
  await printPrepare(LODOP, data, printSetting, tplStr, needCheck);
  // 如果选择了打印机，需要重新设置打印机，否则使用默认的打印机
  const printCopies = printSetting.printCopies ? printSetting.printCopies : 1;
  LODOP.SET_PRINT_COPIES(printCopies);

  const popPreview = isPreview({ printSetting, dataSum });
  popPreview ? LODOP.PREVIEW() : printStatusCommand(LODOP, proxy, PRINT_TYPE.TABLE_BILL);
  if ([266, 349, 69341].includes(+window.group_id) && !Array.isArray(data)) {
    window[`lodopCustomVarsPrint_${data.order_num}`].print_order_num = window.lodopCustomVars.order_num;
  }

  printLog(data, printSetting, printCopies);
}

export async function popUpPrintPreview(LODOP, data, printSetting, tplStr, needCheck) {
  await printPrepare(LODOP, data, printSetting, tplStr, needCheck);
  LODOP.SET_PREVIEW_WINDOW(2, 1, 0, 800, 600, '');
  LODOP.SET_PRINT_MODE('AUTO_CLOSE_PREWINDOW', 1);
  LODOP?.SET_SHOW_MODE?.('LANDSCAPE_DEFROTATED', 1);
  LODOP.PREVIEW();
  await new Promise(resolve => (LODOP.On_Return = resolve)); // eslint-disable-line
}

function parseTableData(LODOP, data, printSetting, tplStr) {
  if (!data.order || data.order.length === 0) {
    return;
  }
  const tplArr = tplStr.split(';');
  // 需要为包含order的打印语句重新生成数据
  const tableHeight = printSetting.table_height ? printSetting.table_height : 28;
  const tableLine = printSetting.table_line ? printSetting.table_line : 12;
  const fontSize = printSetting.td_table_font_size ? printSetting.td_table_font_size : 12;
  const lineHeight = -Math.floor(fontSize * 0.6);
  const fontSizeCmd = `LODOP.SET_PRINT_STYLEA(0, "FontSize", ${fontSize})`;
  const lineHeightCmd = `LODOP.SET_PRINT_STYLEA(0, "LineSpacing", ${lineHeight})`;
  const totalOrderLen = data.order.length;
  const cycle = parseInt(totalOrderLen / tableLine, 0);
  const excludeOrderArr = [];
  const orderArr = [];
  const pStationArr = [];
  const approvalArr = [];
  const feeApprovalArr = [];
  const feeApprovalAggArr = [];
  const payModeArr = [];
  const driverTrNumArr = [];
  const orderStatement = [];
  const pStationStatement = [];
  const approvalStatement = [];
  const feeApprovalStatement = [];
  const feeApprovalAggStatement = [];
  const payModeStatement = [];
  const driverTrNumStatement = [];
  let index = 0;
  let currIndex = 0;
  const systemTpl = [];

  // 提取order模板
  let lastIsOrder = false;
  for (const tplStatement of tplArr) {
    if (tplStatement.indexOf('ADD_PRINT_TEXT') !== false && tplStatement.indexOf('ADD_PRINT_TEXT') >= 0) {
      if (tplStatement.indexOf('order[0]') !== false && tplStatement.indexOf('order[0]') >= 0) {
        orderStatement.push(tplStatement);
        let vNameIndex = 1;
        while (tplArr[currIndex + vNameIndex] && tplArr[currIndex + vNameIndex].includes('SET_PRINT_STYLE')) {
          const vName = tplArr[currIndex + vNameIndex];
          orderStatement.push(vName);
          ++vNameIndex;
        }
        /*
        while (vNameIndex < 4) {
          if (tplArr[currIndex + vNameIndex] && tplArr[currIndex + vNameIndex].indexOf('ContentVName') >= 0) {
            const vName = tplArr[currIndex + vNameIndex]
            orderStatement.push(vName)
          }
          ++vNameIndex
        }
        */
        lastIsOrder = true;
      } else if (tplStatement.indexOf('p_station[0]') !== false && tplStatement.indexOf('p_station[0]') >= 0) {
        pStationStatement.push(tplStatement);
        let vNameIndex = 1;
        while (tplArr[currIndex + vNameIndex] && tplArr[currIndex + vNameIndex].includes('SET_PRINT_STYLE')) {
          const vName = tplArr[currIndex + vNameIndex];
          orderStatement.push(vName);
          ++vNameIndex;
        }
        /*
        while (vNameIndex < 4) {
          const next = tplArr[currIndex + vNameIndex]
          if (!next || next.includes('ADD_PRINT')) break
          if (next && next.includes('ContentVName')) {
            pStationStatement.push(next)
          }
          if (next && next.includes('"ItemType",1)')) {
            pStationStatement.push(next)
          }
          ++vNameIndex
        }
        */
      } else if (tplStatement.indexOf('fee_approval[0]') !== false && tplStatement.indexOf('fee_approval[0]') >= 0) {
        lastIsOrder = true;
        feeApprovalStatement.push(tplStatement);
        let vNameIndex = 1;
        while (tplArr[currIndex + vNameIndex] && tplArr[currIndex + vNameIndex].includes('SET_PRINT_STYLE')) {
          const vName = tplArr[currIndex + vNameIndex];
          orderStatement.push(vName);
          ++vNameIndex;
        }
        lastIsOrder = true;
      } else if (
        tplStatement.indexOf('fee_approval_agg[0]') !== false &&
        tplStatement.indexOf('fee_approval_agg[0]') >= 0
      ) {
        feeApprovalAggStatement.push(tplStatement);
        let vNameIndex = 1;
        while (tplArr[currIndex + vNameIndex] && tplArr[currIndex + vNameIndex].includes('SET_PRINT_STYLE')) {
          const vName = tplArr[currIndex + vNameIndex];
          orderStatement.push(vName);
          ++vNameIndex;
        }
        lastIsOrder = true;
      } else if (tplStatement.indexOf('pay_mode[0]') !== false && tplStatement.indexOf('pay_mode[0]') >= 0) {
        payModeStatement.push(tplStatement);
        let vNameIndex = 1;
        while (tplArr[currIndex + vNameIndex] && tplArr[currIndex + vNameIndex].includes('SET_PRINT_STYLE')) {
          const vName = tplArr[currIndex + vNameIndex];
          orderStatement.push(vName);
          ++vNameIndex;
        }
        lastIsOrder = true;
      } else if (tplStatement.indexOf('driver_tr_num[0]') !== false && tplStatement.indexOf('driver_tr_num[0]') >= 0) {
        driverTrNumStatement.push(tplStatement);
        let vNameIndex = 1;
        while (tplArr[currIndex + vNameIndex] && tplArr[currIndex + vNameIndex].includes('SET_PRINT_STYLE')) {
          const vName = tplArr[currIndex + vNameIndex];
          orderStatement.push(vName);
          ++vNameIndex;
        }
        lastIsOrder = true;
      } else if (tplStatement.indexOf('approval[0]') !== false && tplStatement.indexOf('approval[0]') >= 0) {
        approvalStatement.push(tplStatement);
        let vNameIndex = 1;
        while (tplArr[currIndex + vNameIndex] && tplArr[currIndex + vNameIndex].includes('SET_PRINT_STYLE')) {
          const vName = tplArr[currIndex + vNameIndex];
          orderStatement.push(vName);
          ++vNameIndex;
        }
        /*
        while (vNameIndex < 4) {
          const next = tplArr[currIndex + vNameIndex]
          if (!next || next.includes('ADD_PRINT')) break
          if (next && next.includes('ContentVName')) {
            approvalStatement.push(next)
          }
          if (next && next.includes('"ItemType",1)')) {
            approvalStatement.push(next)
          }
          ++vNameIndex
        }
        */
        lastIsOrder = true;
      } else {
        // 除运单,到站外的其他的打印模板
        excludeOrderArr.push(tplStatement);
        lastIsOrder = false;
      }
    } else {
      !lastIsOrder && excludeOrderArr.push(tplStatement);
    }
    ++currIndex;
  }
  // 生成order模板
  let currTotalCount = 0;
  while (index < cycle + 1) {
    let currCount = 0;
    // if (currTotalCount === 0) {
    //   ++currTotalCount
    //   continue // eslint-disable-line
    // }
    while (currCount < tableLine && currTotalCount < totalOrderLen) {
      currIndex = 0;
      for (let tplStatement of orderStatement) {
        const replaceValue = currCount + index * tableLine;
        const replaceText = `order[${replaceValue}]`;
        if (tplStatement.indexOf('ADD_PRINT_TEXT') >= 0) {
          if (tplStatement.indexOf('order[0]') >= 0) {
            const replaceHeight = currCount * tableHeight;
            tplStatement = tplStatement.replace(/order\[0\]/, replaceText); // eslint-disable-line
            let marginTop = tplStatement.match(/(\d+)/i)[0];
            marginTop = marginTop ? parseInt(marginTop, 0) + replaceHeight : replaceHeight;
            tplStatement = tplStatement.replace(/(\d+)/i, marginTop);
            // 替换模板高度
            orderArr.push(tplStatement);
            orderArr.push(fontSizeCmd);
            orderArr.push(lineHeightCmd);
            /*
            if (orderStatement[currIndex + 1] && orderStatement[currIndex + 1].indexOf('ContentVName') >= 0) {
              let vName = orderStatement[currIndex + 1]
              vName = vName.replace(/order\[0\]/, replaceText)    // eslint-disable-line
              orderArr.push(vName)
            }
            */
          }
        } else if (tplStatement.includes('ContentVName')) {
          let vName = orderStatement[currIndex];
          vName = vName.replace(/order\[0\]/, replaceText); // eslint-disable-line
          orderArr.push(vName);
        } else {
          orderArr.push(tplStatement);
        }
        ++currIndex;
      }
      ++currTotalCount;
      ++currCount;
    }
    orderArr.push('LODOP.NewPageA()');
    ++index;
  }
  // 生成到站信息模板
  index = 0;
  if (data.p_station && data.p_station.length > 0) {
    while (index < data.p_station.length) {
      currIndex = 0;
      for (let tplStatement of pStationStatement) {
        if (tplStatement.indexOf('ADD_PRINT_TEXT') !== false && tplStatement.indexOf('ADD_PRINT_TEXT') >= 0) {
          if (tplStatement.indexOf('p_station[0]') !== false && tplStatement.indexOf('p_station[0]') >= 0) {
            const replaceHeight = index * tableHeight;
            const replaceText = `p_station[${index}]`;
            tplStatement = tplStatement.replace(/p_station\[0\]/, replaceText); // eslint-disable-line
            let marginTop = tplStatement.match(/(\d+)/i)[0];
            marginTop = marginTop ? parseInt(marginTop, 0) + replaceHeight : replaceHeight;
            tplStatement = tplStatement.replace(/(\d+)/i, marginTop);
            // 替换模板高度
            pStationArr.push(tplStatement);
            pStationArr.push(fontSizeCmd);
            pStationArr.push(lineHeightCmd);
          }
        } else if (tplStatement.includes('ContentVName')) {
          const replaceText = `p_station[${index}]`;
          const vName = tplStatement.replace(/p_station\[0\]/, replaceText); // eslint-disable-line
          pStationArr.push(vName);
        } else {
          pStationArr.push(tplStatement);
        }
        ++currIndex;
      }
      ++index;
    }
  }
  // 生成费用信息模版
  index = 0;
  if (data.fee_approval && data.fee_approval.length > 0) {
    while (index < data.fee_approval.length) {
      currIndex = 0;
      for (let tplStatement of feeApprovalStatement) {
        if (tplStatement.indexOf('ADD_PRINT_TEXT') !== false && tplStatement.indexOf('ADD_PRINT_TEXT') >= 0) {
          if (tplStatement.indexOf('fee_approval[0]') !== false && tplStatement.indexOf('fee_approval[0]') >= 0) {
            const replaceHeight = index * tableHeight;
            const replaceText = `fee_approval[${index}]`;
            tplStatement = tplStatement.replace(/fee_approval\[0\]/, replaceText); // eslint-disable-line
            let marginTop = tplStatement.match(/(\d+)/i)[0];
            marginTop = marginTop ? parseInt(marginTop, 0) + replaceHeight : replaceHeight;
            tplStatement = tplStatement.replace(/(\d+)/i, marginTop);
            // 替换模板高度
            feeApprovalArr.push(tplStatement);
            feeApprovalArr.push(fontSizeCmd);
            feeApprovalArr.push(lineHeightCmd);
          }
        } else if (tplStatement.includes('ContentVName')) {
          const replaceText = `approval[${index}]`;
          const vName = tplStatement.replace(/fee_approval\[0\]/, replaceText); // eslint-disable-line
          feeApprovalArr.push(vName);
        } else {
          feeApprovalArr.push(tplStatement);
        }
        ++currIndex;
      }
      ++index;
    }
  }
  // 生成在途费用汇总
  index = 0;
  if (data.fee_approval_agg && data.fee_approval_agg.length > 0) {
    while (index < data.fee_approval_agg.length) {
      currIndex = 0;
      for (let tplStatement of feeApprovalAggStatement) {
        if (tplStatement.indexOf('ADD_PRINT_TEXT') !== false && tplStatement.indexOf('ADD_PRINT_TEXT') >= 0) {
          if (
            tplStatement.indexOf('fee_approval_agg[0]') !== false &&
            tplStatement.indexOf('fee_approval_agg[0]') >= 0
          ) {
            const replaceHeight = index * tableHeight;
            const replaceText = `fee_approval_agg[${index}]`;
            tplStatement = tplStatement.replace(/fee_approval_agg\[0\]/, replaceText); // eslint-disable-line
            let marginTop = tplStatement.match(/(\d+)/i)[0];
            marginTop = marginTop ? parseInt(marginTop, 0) + replaceHeight : replaceHeight;
            tplStatement = tplStatement.replace(/(\d+)/i, marginTop);
            // 替换模板高度
            feeApprovalAggArr.push(tplStatement);
            feeApprovalAggArr.push(fontSizeCmd);
            feeApprovalAggArr.push(lineHeightCmd);
          }
        } else if (tplStatement.includes('ContentVName')) {
          const replaceText = `fee_approval_agg[${index}]`;
          const vName = tplStatement.replace(/fee_approval_agg\[0\]/, replaceText); // eslint-disable-line
          feeApprovalAggArr.push(vName);
        } else {
          feeApprovalAggArr.push(tplStatement);
        }
        ++currIndex;
      }
      ++index;
    }
  }
  // 公司付款信息
  index = 0;
  if (data.pay_mode && data.pay_mode.length > 0) {
    while (index < data.pay_mode.length) {
      currIndex = 0;
      for (let tplStatement of payModeStatement) {
        if (tplStatement.indexOf('ADD_PRINT_TEXT') !== false && tplStatement.indexOf('ADD_PRINT_TEXT') >= 0) {
          if (tplStatement.indexOf('pay_mode[0]') !== false && tplStatement.indexOf('pay_mode[0]') >= 0) {
            const replaceHeight = index * tableHeight;
            const replaceText = `pay_mode[${index}]`;
            tplStatement = tplStatement.replace(/pay_mode\[0\]/, replaceText); // eslint-disable-line
            let marginTop = tplStatement.match(/(\d+)/i)[0];
            marginTop = marginTop ? parseInt(marginTop, 0) + replaceHeight : replaceHeight;
            tplStatement = tplStatement.replace(/(\d+)/i, marginTop);
            // 替换模板高度
            payModeArr.push(tplStatement);
            payModeArr.push(fontSizeCmd);
            payModeArr.push(lineHeightCmd);
          }
        } else if (tplStatement.includes('ContentVName')) {
          const replaceText = `pay_mode[${index}]`;
          const vName = tplStatement.replace(/pay_mode\[0\]/, replaceText); // eslint-disable-line
          payModeArr.push(vName);
        } else {
          payModeArr.push(tplStatement);
        }
        ++currIndex;
      }
      ++index;
    }
  }
  // 账本信息
  index = 0;
  if (data.driver_tr_num && data.driver_tr_num.length > 0) {
    while (index < data.driver_tr_num.length) {
      currIndex = 0;
      for (let tplStatement of driverTrNumStatement) {
        if (tplStatement.indexOf('ADD_PRINT_TEXT') !== false && tplStatement.indexOf('ADD_PRINT_TEXT') >= 0) {
          if (tplStatement.indexOf('driver_tr_num[0]') !== false && tplStatement.indexOf('driver_tr_num[0]') >= 0) {
            const replaceHeight = index * tableHeight;
            const replaceText = `driver_tr_num[${index}]`;
            tplStatement = tplStatement.replace(/driver_tr_num\[0\]/, replaceText); // eslint-disable-line
            let marginTop = tplStatement.match(/(\d+)/i)[0];
            marginTop = marginTop ? parseInt(marginTop, 0) + replaceHeight : replaceHeight;
            tplStatement = tplStatement.replace(/(\d+)/i, marginTop);
            // 替换模板高度
            driverTrNumArr.push(tplStatement);
            driverTrNumArr.push(fontSizeCmd);
            driverTrNumArr.push(lineHeightCmd);
          }
        } else if (tplStatement.includes('ContentVName')) {
          const replaceText = `driver_tr_num[${index}]`;
          const vName = tplStatement.replace(/driver_tr_num\[0\]/, replaceText); // eslint-disable-line
          driverTrNumArr.push(vName);
        } else {
          driverTrNumArr.push(tplStatement);
        }
        ++currIndex;
      }
      ++index;
    }
  }
  // 生成审核信息模板
  index = 0;
  if (data.approval && data.approval.length > 0) {
    while (index < data.approval.length) {
      currIndex = 0;
      for (let tplStatement of approvalStatement) {
        if (tplStatement.indexOf('ADD_PRINT_TEXT') !== false && tplStatement.indexOf('ADD_PRINT_TEXT') >= 0) {
          if (tplStatement.indexOf('approval[0]') !== false && tplStatement.indexOf('approval[0]') >= 0) {
            const replaceHeight = index * tableHeight;
            const replaceText = `approval[${index}]`;
            tplStatement = tplStatement.replace(/approval\[0\]/, replaceText); // eslint-disable-line
            let marginTop = tplStatement.match(/(\d+)/i)[0];
            marginTop = marginTop ? parseInt(marginTop, 0) + replaceHeight : replaceHeight;
            tplStatement = tplStatement.replace(/(\d+)/i, marginTop);
            // 替换模板高度
            approvalArr.push(tplStatement);
            approvalArr.push(fontSizeCmd);
            approvalArr.push(lineHeightCmd);
          }
        } else if (tplStatement.includes('ContentVName')) {
          const replaceText = `approval[${index}]`;
          const vName = tplStatement.replace(/approval\[0\]/, replaceText); // eslint-disable-line
          approvalArr.push(vName);
        } else {
          approvalArr.push(tplStatement);
        }
        ++currIndex;
      }
      ++index;
    }
  }

  eval(systemTpl.join(';')); // eslint-disable-line no-eval
  eval(excludeOrderArr.join(';')); // eslint-disable-line no-eval
  eval(pStationArr.join(';')); // eslint-disable-line no-eval
  eval(approvalArr.join(';')); // eslint-disable-line no-eval
  eval(orderArr.join(';')); // eslint-disable-line no-eval
  eval(feeApprovalArr.join(';')); // eslint-disable-line no-eval
  eval(feeApprovalAggArr.join(';')); // eslint-disable-line no-eval
  eval(payModeArr.join(';')); // eslint-disable-line no-eval
  eval(driverTrNumArr.join(';')); // eslint-disable-line no-eval
}

export function tablePreview(LODOP, data, printSetting) {
  parsePrintData(data, printSetting);
  const tplStr = LODOP.GET_VALUE('ProgramCodes', 0);
  parseTableData(LODOP, data, printSetting, tplStr);
  LODOP?.SET_SHOW_MODE?.('DESIGN_IN_BROWSER', 1);
  LODOP.SET_PRINT_MODE('PROGRAM_CONTENT_BYVAR', true);
  LODOP.PRINT_DESIGN();
}

export async function tablePrint(proxy) {
  const { LODOP, data, printSetting, tplDetail, needCheck, isRetry, dataSum = 1 } = proxy;
  !needCheck && !isRetry && (window.PRINTERRORSTEP = 1);

  const checkResult = await printWait(LODOP, needCheck, printSetting);
  console.log('print --->  checkResult', checkResult);
  if (checkResult !== 1) {
    const correctResult = await printFaultCorrect(checkResult, printSetting);
    const printSettingNext = typeof correctResult === 'object' ? { ...printSetting, ...correctResult } : printSetting;

    const printProxy = {
      LODOP: window.globalLodopObj,
      data,
      printSetting: printSettingNext,
      tplDetail,
      needCheck: false,
      isRetry: true,
      dataSum,
    };
    correctResult && tablePrint(printProxy);
    return;
  }

  parsePrintData(data, printSetting);
  let newTplStr = tplDetail;
  if (printSetting && printSetting.width && printSetting.height) {
    newTplStr = parseTablePrintSetting(LODOP, printSetting, newTplStr);
  }

  // jsscript改为处理数据脚本 2022-12-14
  // if (printSetting.jsscript) {
  //   newTplStr = eval(printSetting.jsscript); // eslint-disable-line no-eval
  // }

  // eval(newTplStr) // eslint-disable-line no-eval
  parseTableData(LODOP, data, printSetting, newTplStr);
  LODOP.SET_PRINT_MODE('PROGRAM_CONTENT_BYVAR', true);
  // 如果选择了打印机，需要重新设置打印机，否则使用默认的打印机
  if (printSetting && printSetting.printer) {
    const printerCount = LODOP.GET_PRINTER_COUNT();
    for (let i = 0; i < printerCount; ++i) {
      const printerName = LODOP.GET_PRINTER_NAME(i);
      if (printerName === printSetting.printer) {
        LODOP.SET_PRINTER_INDEXA(printerName);
      }
    }
  }
  const printCopies = printSetting.print_copies ? printSetting.print_copies : 1;
  LODOP.SET_PRINT_COPIES(printCopies);

  const popPreview = isPreview({ printSetting, dataSum });
  popPreview ? LODOP.PREVIEW() : printStatusCommand(LODOP, proxy, PRINT_TYPE.TABLE_BILL);
}

function format(template) {
  return new Function('return `' + template + '`').apply(template); // eslint-disable-line
}

const debugFunc = htmlStr => {
  // 展示调试信息
  console.log('展示调试信息');
  new PopUp(ModalDialog, {
    content: <div dangerouslySetInnerHTML={{ __html: htmlStr }} />,
    popName: 'LoadPrintDebug',
    title: '装车清单调试信息',
    contentStyle: { width: '800px', height: '500px', overflow: 'scroll' },
    isShow: true,
    autoDestroy: true,
  }).show();
};

const getDebugStr = debugProxy => {
  const { debugStr, flexTimeStart, adjustCol, debugStep, printStep, curPrintTableRef, printTbWidth } = debugProxy;
  const { onlyThTable, iFrameDcmt, LodopStrAryWidth, LODOP, targetWidth, itemStr, oldTableStr } = debugProxy;
  const { directIndex, tableIndex, splitAry, split0Ary, directTableMap } = debugProxy;
  let currDebugStr = debugStr;
  const currFlexTime = new Date().getTime() - flexTimeStart;
  const sumWidth = adjustCol.reduce((val, curr) => val + curr.newWidth, 0); // eslint-disable-line
  currDebugStr = `${currDebugStr}当前表格所有列宽合计值=${sumWidth}<br/>`;
  currDebugStr = `${currDebugStr}自适应调整当前耗时=${currFlexTime}<br/><br/>`;
  if (printStep === debugStep) {
    curPrintTableRef[0].style.whiteSpace = null; // eslint-disable-line
    curPrintTableRef[0].style.tableLayout = 'fixed'; // eslint-disable-line
    curPrintTableRef[0].style.width = `${targetWidth}px`; // eslint-disable-line
    adjustCol.forEach(col => (col.el.width = col.newWidth)); // eslint-disable-line
    onlyThTable && onlyThTable.remove();

    let itemHtmlStr = iFrameDcmt.body.innerHTML;
    const shiftIndex = tableIndex === 0 ? 2 : 3;
    const nextTableTop = +directTableMap[directIndex + shiftIndex] || 5;

    // 添加空白 div 遮挡超出边框的内容 start
    if (tableIndex !== 0) {
      let divHtmlStr = `<div style="width:${printTbWidth}mm;height:${nextTableTop}px;background-color:#FFF;" ></div>`;
      divHtmlStr = `<!DOCTYPE html><html><head><meta http-equiv="content-type" content="text/html; charset="utf-8"><meta http-equiv="X-UA-Compatible" content="IE=edge" /><style>body{margin:0;padding:0;}</style></head><body>${divHtmlStr}</body></html>`;
      divHtmlStr = JSON.stringify(divHtmlStr);
      LodopStrAryWidth.push(`LODOP.ADD_PRINT_HTM(1,0,"${printTbWidth}mm","${nextTableTop}px",${divHtmlStr})`);
      LodopStrAryWidth.push('LODOP.SET_PRINT_STYLEA(0,"LinkedItem",-1)');
      LodopStrAryWidth.push('LODOP.SET_PRINT_STYLEA(0,"Vorient",3)');
    }
    // 添加空白 div 遮挡超出边框的内容 end

    itemHtmlStr = `<!DOCTYPE html><html><head><meta http-equiv="content-type" content="text/html; charset="utf-8"><meta http-equiv="X-UA-Compatible" content="IE=edge" /><style>body{margin:0;padding:0;}</style></head><body>${itemHtmlStr}</body></html>`;

    // 替换当前表格打印高度和上边距 start
    // 因为ADD_PRINT_HTM指令下，定高后，表格实际高度可能要小于自然高度
    // const currTableHeight = curPrintTableRef[0].offsetHeight + nextTableTop
    // currTableHeight = ((currTableHeight / 96) * 25.4) + nextTableTop
    const newTopDirect = `LODOP.ADD_PRINT_TABLE(0,${split0Ary[1]},${split0Ary[2]}`;
    // currTableHeight = rowTrHeight ? `"${currTableHeight}"` : '"BottomMargin:0mm"'
    // currTableHeight = `"BottomMargin:${currTableHeight}mm"`
    // currTableHeight = '"BottomMargin:5mm"'
    const newItemStr = `${newTopDirect}",${splitAry[1]}",${splitAry[2]}`;
    // const newItemStr = `${newTopDirect}","BottomMargin:0mm",${splitAry[2]}`
    // 替换当前表格打印高度和上边距 end

    itemHtmlStr = newItemStr.replace(oldTableStr, JSON.stringify(itemHtmlStr));
    // itemHtmlStr = itemHtmlStr.replace('ADD_PRINT_TABLE', 'ADD_PRINT_HTM')
    // // 用 ADD_PRINT_TABLE 添加DIv后遮不住超出边框的内容，可以解决不连续的问题
    LodopStrAryWidth.push(itemHtmlStr);

    const newTplStr1 = LodopStrAryWidth.join(';');
    eval(newTplStr1); // eslint-disable-line no-eval
    LODOP.SET_PRINTER_INDEXA('Microsoft XPS Document Writer');
    LODOP.PRINT();
    console.log('loadPrintTimeStart = ', new Date().getTime() - window.loadPrintTimeStart);
  }
  return currDebugStr;
};

function v1FlexWidth(LODOP, newTplStr, printSetting, tplDetail) {
  // Todo
  // 渲染自然状态下的表格
  // 渲染后，获取宽度数据
  // 重新组织一遍模版

  // bug 37288 start
  const marginTop = printSetting.margin_top || 0;
  const marginLeft = printSetting.margin_left || 0;
  const { paper, width, height, direction } = printSetting;
  const filterGids = [4586, 5258, 5091, 6075, 61078, 61119, 61574, 62034];
  // bug 37288 这些集团在此问题彻底解决前已经创建了对应模版，为不影响他们使用，先过滤掉。
  // 后面用户提的话再陆续放开。下面4个条件缺一不可
  // 自定义纸张(paper === 'custom') 纵向(direction === 'vertical') 非套打(category === '1') 高级自适应(flex_type === 'complex')
  let pageDirection = 1;
  if (direction === 'horizontal') {
    pageDirection = 2;
  }
  const resetInitPaper =
    direction === 'vertical' && paper && paper === 'custom' && !filterGids.includes(+window.group_id);
  if (resetInitPaper) {
    LODOP.PRINT_INITA(`${marginTop}mm`, `${marginLeft}mm`, `${width}mm`, `${height}mm`, '自定义打印模板');
    LODOP.SET_PRINT_PAGESIZE(pageDirection, `${width}mm`, `${height}mm`, '');
  }
  // bug 37288 end

  const flexTimeStart = new Date().getTime();
  const currUriObj = new URI();
  const queryInfo = URI.parseQuery(currUriObj.query());
  const printStep = +(queryInfo.printStep || '');
  const debug = queryInfo.debug || false;

  const fontSize = +printSetting.table_font_size || 12;
  const rowTrHeight = +printSetting.untd_table_row_height;
  const lineHeight = +printSetting.table_height || 18; // 有设置值取设置值，没有取以前的默认值18
  const fixedMaxMin = printSetting.untd_row_flex || 'fixed'; // max min fixed
  const letterSpace = +printSetting.untd_letter_space || 0;
  const offSetPadding = +printSetting.untd_padding || 1;
  const minFontSize = +printSetting.min_font;
  const sumType = printSetting.sum_display || 'non-display';
  const hasDot = +window.psn_setting.skin_set.__meta.thousandSep === 1;

  const LodopStrAryWidth = [];
  const LodopStrAry = newTplStr.split(';;');
  const totalObj = {};
  const orderTbIndexAry = []; // 运单类表格打印指令的索引 集合数组

  // 获取每个表格的表头字段 start --> 结构: [[], []]
  const thFields = [];
  let orderTbIndexRef = 0;
  tplDetail.split(';LODOP').forEach((lodopItem, itemIndex) => {
    if (lodopItem.includes('<style>table')) {
      const rawFields = lodopItem
        .split('<tr><td>')[1]
        .split('</td></tr>')[0]
        .replace(/<\/td><td>/g, '')
        .split('$');
      const currTableThs = rawFields.reduce((ary, curr) => {
        // 非套打支持二、三级结构a.b, a.b.c
        curr.length && ary.push(curr.split('.')[curr.split('.').length - 1].replace('}', ''));
        return ary;
      }, []);
      thFields.push(currTableThs);
      if (lodopItem.includes('.order.')) {
        // 找到运单类表格在所有表格当中的位置（索引）
        orderTbIndexAry.push(orderTbIndexRef);
      }
      orderTbIndexRef++;
    }
  });
  // 获取每个表格的表头字段 end

  let debugStr = '';
  let debugStep = 1;
  let tableIndex = 0; // 表格索引
  let firstDirectAry = []; // 第一个打印元素的指令参数值

  let No1NormalTbIndex; // 第一个普通表格, 控制表格打印区域高度
  let btm1ItemTypeIndex; // 最后一个普通表格，后面第一个页眉页脚的指令索引
  let No1TbTop; // 第一个普通表格, 控制表格打印区域高度 的起始位置
  let No1TbBtm; // 第一个普通表格, 控制表格打印区域高度 的结束位置

  const updateNo1TbInfo = (currDirect, dctI, topVal) => {
    if (No1NormalTbIndex) {
      return false;
    }
    // 获取第一个普通表格的索引和上边距
    let untilNextTbIndex = 1;
    const topEnd = () => {
      const topEndDirectStr = LodopStrAry[dctI + untilNextTbIndex];
      return (
        topEndDirectStr && (!topEndDirectStr.includes('SET_PRINT_STYLEA') || topEndDirectStr.includes('"ItemType"'))
      );
    };
    // 两个打印项之间，都是SET_PRINT_STYLEA打印指令
    const is1Normal = () => {
      let resVal = true;
      const canLoop = untilNextTbIndex + dctI <= LodopStrAry.length;
      while (topEnd() && canLoop) {
        // 直到下一个打印项 || 所有打印指令结束
        const currDictStr = LodopStrAry[dctI + untilNextTbIndex];
        if (currDictStr.includes('"ItemType",1)')) {
          resVal = false;
        }
        if (!LodopStrAry[dctI + untilNextTbIndex].includes('SET_PRINT_STYLEA')) {
          break;
        }
        untilNextTbIndex++;
      }
      return resVal;
    };
    // 先看是不是第一个普通表格
    const is1NormalTb = is1Normal();
    if (is1NormalTb) {
      // 是的话更新第一个普通表格的总体索引值
      No1NormalTbIndex = dctI;
      // 取高度值
      No1TbTop = topVal;
    }
  };
  // 获取所有表格的上边距 start
  const getTableTop = (currDirect, dctI) => {
    if (!currDirect.includes('<style>table')) {
      return 0;
    }
    const currTbTop = currDirect.split(',')[0].split('(')[1] || 0;
    updateNo1TbInfo(currDirect, dctI, currTbTop);
    return currTbTop;
  };
  const directTableMapAll = LodopStrAry.reduce((all, curr, dctI) => [...all, getTableTop(curr, dctI)], []);
  const directTableMap = directTableMapAll.filter(val => val);
  !No1NormalTbIndex && (No1NormalTbIndex = LodopStrAry.length);
  // 获取所有表格的上边距 end

  // 倒序获取 普通表格后面第一个页眉页脚的上边距 start
  let btm1ItemTypeDirect;
  const reverseDictAry = [...LodopStrAry].reverse();
  reverseDictAry.filter((currDirect, dctI) => {
    if (!currDirect.includes('<style>table') || btm1ItemTypeDirect) {
      return false;
    }
    let canLoop = true;
    let untilPreElemIndex = 1;
    const btmEnd = () => {
      const btmEndDirectStr = reverseDictAry[dctI - untilPreElemIndex];
      return btmEndDirectStr && !btmEndDirectStr.includes('SET_PRINT_STYLEA');
    };
    const isLast1Normal = () => {
      let resVal = true;
      canLoop = untilPreElemIndex <= dctI;
      while (btmEnd() && canLoop) {
        const currDictStr = reverseDictAry[dctI - untilPreElemIndex];
        if (currDictStr.includes('"ItemType",1)')) {
          resVal = false;
        }
        untilPreElemIndex++;
      }
      return resVal;
    };
    // 是不是倒序第一个普通表格
    const isLast1NormalTb = isLast1Normal();
    if (isLast1NormalTb && canLoop && !btm1ItemTypeDirect) {
      // 是倒序第一个普通表格，且（倒序）上面还有其它打印元素， 才有可能设置表格打印区域高度
      let untilPrePageIndex = 1;
      let subElemIndex = 0;
      const ItemTypeEnd = () => {
        const itemTypeDirectStr = reverseDictAry[dctI - untilPrePageIndex];
        return (
          itemTypeDirectStr &&
          !itemTypeDirectStr.includes('"ItemType",1)') &&
          !itemTypeDirectStr.includes('"ItemType",2)')
        );
      };
      const subEnd = () => {
        const subDirectStr = reverseDictAry[dctI - untilPrePageIndex - subElemIndex];
        return subDirectStr && (!subDirectStr.includes('SET_PRINT_STYLEA') || subDirectStr.includes('"ItemType"'));
      };
      // 如果（倒序）上面的元素都不是页眉页脚，也不用处理
      while (ItemTypeEnd() && untilPrePageIndex <= dctI && !btm1ItemTypeDirect) {
        const whileDirect = reverseDictAry[dctI - untilPrePageIndex];
        if (!whileDirect.includes('SET_PRINT_STYLEA')) {
          const whileDirectIndex = dctI - untilPrePageIndex;
          // 有打印内容的打印指令； 不是打印内容的打印指令继续循环

          // 判断 whileDirect 打印项是不是页眉页脚
          while (!btm1ItemTypeDirect && subEnd() && untilPrePageIndex + subElemIndex <= dctI) {
            const subItemIndex = dctI - untilPrePageIndex - subElemIndex;
            const tmpDirect = reverseDictAry[subItemIndex];
            if (tmpDirect.includes('"ItemType",1)') || tmpDirect.includes('"ItemType",2)')) {
              btm1ItemTypeDirect = whileDirect;
              btm1ItemTypeIndex = LodopStrAry.length - 1 - whileDirectIndex;
            }
            subElemIndex++;
            if (!reverseDictAry[dctI - untilPrePageIndex - subElemIndex]) {
              break;
            }
            if (!reverseDictAry[dctI - untilPrePageIndex - subElemIndex].includes('SET_PRINT_STYLEA')) {
              break;
            }
          }
        }
        untilPrePageIndex++;
      }
      btm1ItemTypeDirect && (No1TbBtm = btm1ItemTypeDirect.split(',')[0].split('(')[1] || 0);
    }
    return 'reverseDictAry';
  });
  !btm1ItemTypeIndex && (btm1ItemTypeIndex = LodopStrAry.length);
  // 倒序获取 普通表格后面第一个页眉页脚的上边距 end

  LodopStrAry.filter((itemStr, directIndex) => {
    let currItemStr = itemStr.replace(/[\r\n]+/g, '\\n'); // 替换中文换行符↵
    // if (itemStr.includes('0,"LinkedItem",-1)')) {
    //   currItemStr = itemStr.replace('-1', '-2')
    // }
    if (!itemStr.includes('<style>table')) {
      if (currItemStr.includes('"<img')) {
        // 38752
        const imgSplit = currItemStr.split('"<img');
        const imgLodop = imgSplit[0];
        const imgDom = imgSplit[1].split('")')[0];
        const newImgDomStr = `<img ${imgDom}`;
        const newImgDom = JSON.stringify(newImgDomStr);
        const newImgPrint = `${imgLodop}${newImgDom})"`;
        currItemStr = newImgPrint.replace('")"', '")');
      }
      if (directIndex === No1NormalTbIndex) {
        firstDirectAry = currItemStr.split(',');
      }
      LodopStrAryWidth.push(currItemStr); // currItemStr 仅在此处使用
      return false;
    }

    // 插入合计的位置 只能是在表格后面的style指令汇总完，并且开始下一个表格之前插入 start
    // const nextDirectStr = LodopStrAry[directIndex + 1]
    // const canTotal = totalObj[tableIndex - 1] && (!nextDirectStr || !nextDirectStr.includes('SET_PRINT_STYLEA'))
    // if (canTotal) {
    if (totalObj[tableIndex - 1]) {
      LodopStrAryWidth.push(totalObj[tableIndex - 1]);
      LodopStrAryWidth.push('LODOP.SET_PRINT_STYLEA(0,"LinkedItem",-1)');
      LodopStrAryWidth.push('LODOP.SET_PRINT_STYLEA(0,"Vorient",3)');
      totalObj[tableIndex - 1] = null;
    }
    // 插入合计的位置 只能是在表格后面的style指令汇总完，并且开始下一个表格之前插入 end

    const opDomTime = new Date().getTime();

    // 插入iFrame start
    const natureIframeRef = document.createElement('iframe');
    natureIframeRef.id = 'natureIframeRef';
    natureIframeRef.width = '100000px';
    document.body.appendChild(natureIframeRef);
    // 插入iFrame end

    // 插入要打印的原始表格 start
    const splitAry = itemStr.split('",');
    const oldTableStr = `${splitAry[2].split('")')[0]}"`; // 有一部分字段的标题是带括号的
    let natureTableStr = eval(oldTableStr); // eslint-disable-line
    const thPadding = 3; // Math.floor(fontSize / 3)
    const split0Ary = splitAry[0].split(',');

    // 获取 打印时的表格宽度 start
    let printTbWidth = printSetting.direction === 'horizontal' ? +printSetting.height - 10 : +printSetting.width - 10; // mm
    printTbWidth = Math.floor((+printTbWidth / 25.4) * 96); // px

    const firstElemLeft = 0; // 和第一个元素无关，是相对于相对元素的左边距 firstDirectAry[1] || 0 // px
    const schemeLeft = Math.ceil(((+printSetting.margin_left || 0) / 25.4) * 96) || 0; // px
    const sumScheme = schemeLeft + (+split0Ary[1] || 0); // px
    // const tableShouldLeft = Math.max(firstElemLeft, sumScheme)
    const tableShouldLeft = +firstElemLeft + sumScheme;
    // 第一个元素的左边距 + 表格自身左边距 + 打印方案左边距
    // 这么处理是因为第一个打印元素的左边距会影响实际打印时，表格的左边距

    const isPageFoot = directIndex < No1NormalTbIndex || directIndex >= btm1ItemTypeIndex;
    const oriTbWidthMM = +split0Ary[2].slice(0, -2).slice(1) || 0; // mm
    const oriTbWidthPX = (oriTbWidthMM / 25.4) * 96; // px
    const targetWidth = isPageFoot ? oriTbWidthPX : printTbWidth - tableShouldLeft; // px
    // 获取 打印时的表格宽度 end

    // const tdDivRowInit = Math.floor(rowTrHeight / fontSize)    Math.floor(32 / 14) = 2
    // const tdDivIsInit = (rowTrHeight % fontSize) < (fontSize / 2) // 取整数n倍还是n.5倍   4 < 7
    // const tdDivMulit = tdDivIsInit ? tdDivRowInit : (tdDivRowInit + 0.5)      2
    // const tdDivMaxH = rowTrHeight ? (tdDivMulit * fontSize) : rowTrHeight   2 * 14 = 28

    // 有了最大高度后，在最大高度内自适应
    const tdMinHStr = ['fixed', 'min'].includes(fixedMaxMin) && rowTrHeight ? `min-height:${rowTrHeight}px;` : '';
    const tdDivMaxHStr = ['fixed', 'max'].includes(fixedMaxMin) && rowTrHeight ? `max-height:${rowTrHeight}px;` : '';

    let appendStyle = `table{width:auto;}th{line-height:${fontSize}px;padding-top:${thPadding}px;padding-bottom:${thPadding}px;}`;
    appendStyle += `td{${tdMinHStr}padding:0;}.td-div{${tdDivMaxHStr}overflow:hidden;line-height:${lineHeight}px;letter-spacing:${letterSpace};display:inline-block;}</style>`;
    // 关于上一行的 display:inline-block; 去掉后，IE8 下打印，个位数的值会不居中显示； 加上后， win7 IE11， 最后一行有值的单元格，底部边线会变粗 38977
    natureTableStr = natureTableStr.replace(/<\/style>/g, appendStyle);
    natureTableStr = natureTableStr.replace(/<td>/g, '<td><div class="td-div" >');
    natureTableStr = natureTableStr.replace(/<\/td>/g, '</div></td>');
    natureTableStr = natureTableStr.replace(/<th>/g, '<th><div class="th-div" >');
    natureTableStr = natureTableStr.replace(/<\/th>/g, '</div></th>');

    const iFrameDcmt = natureIframeRef.contentDocument;
    iFrameDcmt.body.innerHTML = natureTableStr;

    // 插入要打印的原始表格 end

    // const curPrintTableRef = iFrameDcmt.getElementsByTagName('table')
    const curPrintTableRef = Array.from(iFrameDcmt.getElementsByTagName('table'));
    const trNum = curPrintTableRef[0].children[1].children.length;
    if (!trNum) {
      // 插入一行空的，否则后面代码会报错，最后再删掉
      const thNum = curPrintTableRef[0].children[0].children[0].children.length;
      curPrintTableRef[0].children[1].innerHTML = `<tr>${Array.from({ length: thNum }, () => '<td></td>').join(
        ',',
      )}</tr>`;
    }
    const curPrintPureTds = Array.from(curPrintTableRef[0].children[1].children[0].children);
    const curPrintTrs = Array.from(curPrintTableRef[0].children[1].children);

    // 插入独立表头 start
    const theadClone = curPrintTableRef[0].children[0].cloneNode(true);
    const onlyTheadTableRef = document.createElement('table');
    curPrintTableRef[0].style['font-family'] = onlyTheadTableRef.style['font-family'] = '宋体';
    curPrintTableRef[0].style.whiteSpace = onlyTheadTableRef.style.whiteSpace = 'nowrap';
    onlyTheadTableRef.appendChild(theadClone);
    iFrameDcmt.body.appendChild(onlyTheadTableRef);
    const onlyThTable = iFrameDcmt.body.querySelectorAll('table')[1];
    // 插入独立表头 end

    // 将完整的表格 curPrintTableRef 去掉thead start
    curPrintTableRef[0].children[0].remove();
    // 将完整的表格 curPrintTableRef 去掉thead end

    // 断点调试用
    // natureIframeRef.style.position = 'absolute'
    // natureIframeRef.style.top = '10px'
    // natureIframeRef.style['z-index'] = '999'
    debugStr = `${debugStr} 操作Dom净耗时= ${new Date().getTime() - opDomTime}<br/>`;

    // 最大宽度限制值的获取 start
    const maxTimeStart = new Date().getTime();
    const fieldsMap = thFields[tableIndex].reduce((ary, curr) => {
      if (maxWidthConf.four.includes(curr)) {
        ary.push({ maxWidth: 4 * fontSize, fieldName: curr });
      } else if (maxWidthConf.eight.includes(curr)) {
        ary.push({ maxWidth: 8 * fontSize, fieldName: curr });
      } else {
        ary.push({ maxWidth: 20 * fontSize, fieldName: curr });
      }
      return ary;
    }, []);
    debugStr = `${debugStr} 获取最大宽度限制 净耗时= ${new Date().getTime() - maxTimeStart}<br/>`;
    // 最大宽度限制值的获取 end

    // 此处统一 相同表头字数的表头宽度（只有表头的情况） start
    const onlyThs = theadClone.children[0].children;
    // const onlyThNumMap = {}
    // for (const thItem of onlyThs) {
    //   const curThLg = thItem.innerText.length
    //   if (!onlyThNumMap[curThLg]) {
    //     onlyThNumMap[curThLg] = thItem.clientWidth
    //   } else if (thItem.clientWidth > +onlyThNumMap[curThLg]) {
    //     onlyThNumMap[curThLg] = thItem.clientWidth
    //   }
    // }
    // 此处统一 相同表头字数的表头宽度（只有表头的情况） end

    // 计算一个表头字体大小 （表头加粗） start
    // const thFontSize = Math.ceil(onlyThs[0].offsetWidth / onlyThs[0].innerText.length)
    // const thFontSize = Math.ceil(onlyThs[0].clientWidth / onlyThs[0].innerText.length) // 取该值会导致左宽右窄
    // const thFontSize = onlyThs[0].offsetWidth / onlyThs[0].innerText.length
    const thFontSize = +fontSize;
    // 计算一个表头字体大小 （表头加粗） end

    // 按照"最大内容宽度"自大到小排序的所有列 start
    const sortTimeStart = new Date().getTime();
    const adjustCol = curPrintPureTds.map((currCol, i) => {
      const thElem = onlyThs[i];

      const { fieldName } = fieldsMap[i];
      const isRemark = stretchConf.remark.includes(fieldName);
      const isAddress = stretchConf.address.includes(fieldName);
      const isEmpty = thElem.innerText === '空白列';
      const fullInclude = maxWidthConf.full.includes(fieldName);

      const thWidth = Math.ceil(thElem.clientWidth);
      const cntWidth = Math.ceil(currCol.clientWidth);
      const { maxWidth } = fieldsMap[i];

      const isFixedWidth = thElem.width || false;
      const newWidth = isFixedWidth ? +thElem.width || 0 : Math.min(Math.max(thWidth, cntWidth), maxWidth);

      const currColInfo = {
        el: thElem,
        maxWidth,
        colIndex: i,
        name: thElem.innerText,
        thWidth,
        cntWidth,
        newWidth,
        isFixedWidth,
        isRemark,
        isAddress,
        isEmpty,
        fieldName,
      };

      return currColInfo;
    });
    const getSort = col => col.cntWidth;
    adjustCol.sort((a, b) => getSort(b) - getSort(a));
    debugStr = `${debugStr} 列排序净耗时= ${new Date().getTime() - sortTimeStart}<br/>`;
    // 按照"最大内容宽度"自大到小排序的所有列 end

    curPrintTableRef[0].remove();
    curPrintTableRef[0].remove();
    curPrintTableRef[0].style.display = 'none';
    curPrintTableRef[0].style.display = 'none';

    // 移除运单类表格的最后一行合计信息
    const lastTrSum = curPrintTableRef[0].children[0].lastElementChild.cloneNode(true);
    if (sumType !== 'non-display-total' && orderTbIndexAry.includes(tableIndex)) {
      curPrintTableRef[0].children[0].lastElementChild.remove();
    }

    // 获取 表格初始自然显示状态所占宽度 与 打印时表格整体宽度的 大小 start
    const targetPadWidth = targetWidth - offSetPadding * 2 * adjustCol.length;
    let calcTableWidth = adjustCol.reduce((val, curr) => val + curr.newWidth, 0); // eslint-disable-line
    calcTableWidth += adjustCol.length + 1;
    let delta = +calcTableWidth - targetPadWidth;
    delta = Math.ceil(delta);
    // 获取 表格初始自然显示状态所占宽度 与 打印时表格整体宽度的 大小 end

    // 取出thead，拼到tbody里面，形成完整可用的表格 start
    const theadTbodyTimeStart = new Date().getTime();
    const thTrRef = onlyThTable.children[0].children[0];
    const theadOroxy = curPrintTableRef[0].createTHead();
    theadOroxy.appendChild(thTrRef);
    debugStr = `${debugStr} 取出thead，拼到tbody里面，形成完整可用的表格 净耗时= ${
      new Date().getTime() - theadTbodyTimeStart
    }<br/>`;
    // 取出thead，拼到tbody里面，形成完整可用的表格 end

    if (debug) {
      const formatDebugTimeStart = new Date().getTime();
      const debugMaxCnt = adjustCol.reduce(
        (all, curr) =>
          all.push(`th=${curr.name}, thWidth=${curr.thWidth}, cntWidth=${curr.cntWidth}, newWidth=${curr.newWidth}`) &&
          all,
        [],
      );
      debugStr = `${debugStr}${debugStep}、第${
        tableIndex + 1
      }个表格：按最大内容宽度排序后的列宽信息<br/>${JSON.stringify(`${debugMaxCnt.join(';<br/>')}`)}<br/>`;
      debugStr = `${debugStr} 形成debug信息净耗时= ${new Date().getTime() - formatDebugTimeStart}<br/>`;
      debugStr = `${debugStr}当前表格整体宽度=${calcTableWidth}, 打印时表格整体宽度的=${targetWidth}。两者差值为： ${delta}<br/>`;
      debugStr = getDebugStr({
        debugStr,
        flexTimeStart,
        adjustCol,
        debugStep,
        printStep,
        curPrintTableRef,
        onlyThTable,
        iFrameDcmt,
        LodopStrAryWidth,
        LODOP,
        targetWidth,
        itemStr,
        oldTableStr,
        directIndex,
        tableIndex,
        directTableMap,
        printTbWidth,
        splitAry,
        split0Ary,
      });
      debugStep++;
    }

    // 同时等比例操作所有列。 deltaWidth > 0 ? 拉伸 ： 缩小 start
    const colsOp = (deltaWidth, handleNum = adjustCol.length) => {
      // const handleNum = 8 // adjustCol.length
      let doneCols = 0;
      let _fontSize = +fontSize;
      const deltaAbs = Math.abs(deltaWidth);
      const dotWidth = deltaAbs / handleNum; // 小数点宽度
      let everyWidth = deltaWidth > 0 ? Math.floor(dotWidth) : Math.ceil(dotWidth);
      if (everyWidth === 0) {
        return false;
      }
      if (deltaWidth < 0) {
        // 压缩列宽操作
        // if (everyWidth < fontSize) {
        //   return false
        // }
        everyWidth = Math.ceil(everyWidth / _fontSize) * _fontSize;
        let usedDelta = 0;
        for (const col of adjustCol) {
          if (col.isFixedWidth) {
            continue; // eslint-disable-line
          }
          if (maxWidthConf.full.includes(col.fieldName)) {
            let _newWidth = col.newWidth - everyWidth;
            if (_newWidth < col.thWidth) {
              _fontSize = thFontSize;
            }
            if (_newWidth <= _fontSize) {
              _newWidth = _fontSize;
              doneCols++;
            } else {
              _newWidth = Math.ceil(_newWidth / _fontSize) * _fontSize;
              if (_newWidth <= _fontSize) {
                _newWidth = _fontSize;
                doneCols++;
              }
            }
            usedDelta += col.newWidth - _newWidth;
            col.newWidth = _newWidth;
            if (deltaAbs - usedDelta < 0) {
              break;
            }
          }
        }
        const leftWidth = deltaAbs - usedDelta;
        const leftCols = maxWidthConf.full.length - doneCols;
        if (leftWidth > 0 && leftCols > 0 && usedDelta !== 0) {
          colsOp(-leftWidth, leftCols);
        }
      } else {
        let opCount = 1;
        for (const col of adjustCol) {
          if (col.isFixedWidth) {
            continue; // eslint-disable-line
          }
          if (opCount === handleNum) {
            const leftWidth = Math.abs(deltaAbs - everyWidth * opCount);
            col.newWidth += leftWidth;
            break;
          }
          col.newWidth += everyWidth;
          opCount++;
        }
      }

      if (debug) {
        debugStr += `${debugStep}、第${
          tableIndex + 1
        }个表格: 同时等比例操作所有列<br/>当前delta=${deltaWidth}，everyWidth= ${everyWidth}<br/>`;
        const debugColsOp = adjustCol.reduce(
          (all, curr) => all.push(`th=${curr.name}, newWidth=${curr.newWidth}`) && all,
          [],
        );
        debugStr = `${debugStr}同时等比例操作所有列之后，每列当前宽度为：<br/>${JSON.stringify(
          `${debugColsOp.join(';<br/>')}`,
        )}<br/>`;
        debugStr = getDebugStr({
          debugStr,
          flexTimeStart,
          adjustCol,
          debugStep,
          printStep,
          curPrintTableRef,
          onlyThTable,
          iFrameDcmt,
          LodopStrAryWidth,
          LODOP,
          targetWidth,
          itemStr,
          oldTableStr,
          directIndex,
          tableIndex,
          directTableMap,
          printTbWidth,
          splitAry,
          split0Ary,
        });
        debugStep++;
      }
    };
    // 同时等比例操作所有列。 deltaWidth > 0 ? 拉伸 ： 缩小 end

    // 列的拉伸放大操作。start
    const stretchWidth = deltaWidth => {
      // deltaWidth must be > 0
      let everyWidth = deltaWidth;
      const emptyCount = adjustCol.reduce((count, curr) => (curr.isEmpty && !curr.isFixedWidth ? ++count : count), 0); // eslint-disable-line
      const remarkCount = adjustCol.reduce((count, curr) => (curr.isRemark && !curr.isFixedWidth ? ++count : count), 0); // eslint-disable-line
      const addressCount = adjustCol.reduce(
        (count, curr) => (curr.isAddress && !curr.isFixedWidth ? ++count : count),
        0,
      ); // eslint-disable-line

      const stretch = (stretchCount, type) => {
        if (stretchCount > 1) {
          everyWidth = Math.floor(deltaWidth / stretchCount);
        }
        let stretchIndex = 1;
        for (const col of adjustCol) {
          if (!col[type]) {
            continue; // eslint-disable-line
          }
          if (stretchCount === stretchIndex) {
            const leftWidth = Math.abs(deltaWidth - everyWidth * (stretchCount - 1));
            col.newWidth += leftWidth;
          } else {
            col.newWidth += everyWidth;
          }
          stretchIndex++;
        }
      };

      if (emptyCount !== 0) {
        // 先拉伸空白列
        stretch(emptyCount, 'isEmpty');
        debugStr += '拉伸了空白列<br/>';
      } else if (remarkCount !== 0) {
        // 再拉伸备注列
        stretch(remarkCount, 'isRemark');
        debugStr += '拉伸了运单备注列<br/>';
      } else if (addressCount !== 0) {
        // 再拉伸地址列
        stretch(addressCount, 'isAddress');
        debugStr += '拉伸了地址列<br/>';
      } else {
        // 同比例放大所有列
        colsOp(deltaWidth);
        debugStr += '同比例放大所有列<br/>';
      }
      if (debug) {
        debugStr = getDebugStr({
          debugStr,
          flexTimeStart,
          adjustCol,
          debugStep,
          printStep,
          curPrintTableRef,
          onlyThTable,
          iFrameDcmt,
          LodopStrAryWidth,
          LODOP,
          targetWidth,
          itemStr,
          oldTableStr,
          directIndex,
          tableIndex,
          directTableMap,
          printTbWidth,
          splitAry,
          split0Ary,
        });
        debugStep++;
      }
    };
    // 列的拉伸放大操作。end

    // 处理字体大小 start
    const handleFont = col => {
      // if (!maxWidthConf.full.includes(col.fieldName)) {
      //   return false
      // }
      const forEachTime = new Date().getTime();
      const currColWidth = col.newWidth;
      curPrintTrs.forEach((tr, rowIndex) => {
        const currTdRef = tr.children[col.colIndex];
        const currDivRef = currTdRef.children[0];

        currDivRef.align = 'left'; // 只有指定的这些列，左对齐，其它的列默认都是居中对齐
        currDivRef.style.display = 'block';

        let newFontSize = fontSize;
        let newLineHeight = lineHeight;
        const currTdNum = currDivRef.innerText.length; // 当前单元格字数
        // 字体缩小处理逻辑 start
        // if (col.newWidth >= col.thWidth) { // 内容宽度比表头大的时候才进行字体缩小
        if (col.cntWidth >= col.newWidth && minFontSize) {
          // 货物名称两行3个字
          // 等号是因为，表头与当前列宽相等又换行的情况，此时也应该缩小字体
          const countEveryRow = Math.floor(currColWidth / fontSize); // 每一行的字数
          const rowsDone = Math.floor(currTdNum / countEveryRow); // 整行数量
          const leftNum = currTdNum - rowsDone * countEveryRow;
          // 最后一行整好是3个字以内的时候，进行换行处理
          const isFull = rowsDone * countEveryRow === currTdNum;
          const lastNum = isFull ? countEveryRow : leftNum;
          const canDo = isFull ? rowsDone > 1 : rowsDone >= 1;
          if (lastNum > 0 && lastNum <= 3 && canDo) {
            const rowsNum = isFull ? rowsDone - 1 : rowsDone;
            const shouldNum = Math.ceil(currTdNum / rowsNum); // 调整完之后，每行应该显示的字数
            const shouldFontSize = Math.floor(currColWidth / shouldNum); // 调整完之后，当前单元格字体应有的大小
            const canAdjust = shouldFontSize >= minFontSize;
            if (canAdjust) {
              newFontSize = shouldFontSize;
              newLineHeight = shouldFontSize;
              currDivRef.style.fontSize = `${shouldFontSize}px`;
              currDivRef.style.lineHeight = `${newLineHeight}px`;
              const debugFont = `当前处理单元格：th=${col.name}, 行数为${
                rowIndex + 1
              };调整后字体大小为${shouldFontSize}<br/>`;
              debugStr += debugFont;
            } else {
              const debugCanFont = `当前处理单元格：th=${col.name}, 行数为${
                rowIndex + 1
              };调整后字体大小为${shouldFontSize}，不具备调整条件<br/>`;
              debugStr += debugCanFont;
            }
          } else {
            const debugCanFont = `当前处理单元格：th=${col.name}, 行数为${
              rowIndex + 1
            };整行数量rowsDone=${rowsDone}，剩余字数leftNum=${leftNum}, 不具备调整条件<br/>`;
            debugStr += debugCanFont;
          }
        }
        // 字体缩小处理逻辑 end

        // 遮挡的单元格要调整上边距 start
        const newCountEveryRow = Math.floor(currColWidth / newFontSize); // 每一行的字数
        const rowsTotal = Math.ceil(currTdNum / newCountEveryRow); // 总行数
        const lastShowHeight = rowTrHeight % newLineHeight >= newFontSize / 2; // 最后一行能否显示出来； 避免被截断行不显示
        if (rowTrHeight && rowsTotal * newLineHeight > rowTrHeight && lastShowHeight) {
          // const offSetPx = Math.ceil((newLineHeight - newFontSize) / 2)
          // currDivRef.style.maxHeight = `${+rowTrHeight + offSetPx}px`
          // currDivRef.style.marginTop = `-${offSetPx}px`
          currDivRef.style.lineHeight = 1;
        }
        // 遮挡的单元格要调整上边距 end
      });
      const debugFont = `遍历当前列==${col.name}==所有行用时：${new Date().getTime() - forEachTime}<br/>`;
      debugStr += debugFont;
    };
    // 处理字体大小 end

    // 处理表头不换行 start
    const thNowrap = (col, thTxt, halfThNum) => {
      col.el.style.whiteSpace = 'nowrap'; // eslint-disable-line
      col.el.style.wordWrap = 'normal'; // eslint-disable-line
      col.el.style.wordBreak = 'normal'; // eslint-disable-line
      col.el.innerHTML = `${thTxt.slice(0, halfThNum)}<br/>${thTxt.slice(halfThNum)}`; // eslint-disable-line
    };
    // 处理表头不换行 end

    // 所有列 循环处理 start
    if (delta > 0) {
      for (const col of adjustCol) {
        const halfThNum = Math.ceil(col.name.length / 2);

        const halfCnt = Math.ceil(col.cntWidth / 2);
        const halfTh = Math.ceil(col.thWidth / 2);
        let currCalcWidth = Math.max(halfCnt, halfTh);

        let calcFontSize = col.newWidth > col.thWidth ? fontSize : thFontSize;
        currCalcWidth = Math.ceil(currCalcWidth / calcFontSize) * calcFontSize;
        const subDelta = col.newWidth - currCalcWidth; // 当前列 减小的宽度

        const isAppoint = maxWidthConf.full.includes(col.fieldName);
        const newWidth3Font = col.newWidth <= fontSize * 3 && col.fieldName === 'arr';

        if ((!isAppoint && col.cntWidth > col.thWidth) || col.isFixedWidth || newWidth3Font) {
          const unOpCol = `当前循环列为 ${col.name}，thWidth=${col.thWidth}, cntWidth=${col.cntWidth}, 无需处理<br/>`;
        } else if (!isAppoint && col.cntWidth <= col.thWidth) {
          // 标题宽度比内容宽度大，但又相差很小的时候，会导致内容换行
          let newMaxWidth = Math.max(col.cntWidth, halfTh);
          newMaxWidth = col.cntWidth < halfTh ? Math.ceil(newMaxWidth / calcFontSize) * calcFontSize : newMaxWidth;
          delta = Math.ceil(delta - (col.newWidth - newMaxWidth));
          col.newWidth = newMaxWidth;
          const newMaxWidthStr = `当前循环列为 ${col.name}, halfCnt=${halfCnt}, halfTh=${halfTh}, newWidth=newMaxWidthStr=${newMaxWidth}<br/><br/>`;
          debugStr += newMaxWidthStr;
          if (delta < 0) {
            break;
          }
        } else if (delta - subDelta < 0) {
          col.newWidth = currCalcWidth;
          // thNowrap(col, col.name, halfThNum)
          // handleFont(col)
          delta = Math.ceil(subDelta - delta);
          stretchWidth(delta); // Todo 按情形一拉伸剩余列
          delta = 0;
          const maxHalf = `当前循环列为 ${col.name}, halfCnt=${halfCnt}, halfTh=${halfTh}, newWidth=maxHalf=${currCalcWidth}<br/><br/>`;
          debugStr += maxHalf;
          break;
        } else if (delta - (col.newWidth - col.maxWidth) <= 0) {
          delta = Math.ceil(Math.abs(col.newWidth - col.maxWidth) - delta);
          col.newWidth = col.maxWidth;
          // thNowrap(col, col.name, halfThNum)
          // handleFont(col)
          stretchWidth(delta); // Todo 按情形一拉伸剩余列
          delta = 0;
          const maxRes = `当前循环列为 ${col.name}, maxWidth=${col.maxWidth}, newWidth=maxWidth=${col.maxWidth}<br/><br/>`;
          debugStr += maxRes;
          break;
        } else {
          let maxMin = Math.max(Math.min(halfCnt, col.maxWidth), halfTh);
          calcFontSize = maxMin > col.thWidth ? fontSize : thFontSize;
          maxMin = Math.ceil(maxMin / calcFontSize) * calcFontSize;
          delta = Math.ceil(delta - (col.newWidth - maxMin));
          col.newWidth = maxMin;
          // thNowrap(col, col.name, halfThNum)
          // handleFont(col)
          const maxMinStr = `当前循环列为 ${col.name}, halfCnt=${halfCnt}, maxWidth=${col.maxWidth}, halfTh=${halfTh}, newWidth=maxMin=${maxMin}<br/><br/>`;
          debugStr += maxMinStr;
        }
      }
    } else {
      stretchWidth(Math.abs(delta));
    }
    // 所有列 循环处理 end

    if (debug) {
      const debugLoop = adjustCol.reduce(
        (all, curr) => all.push(`th=${curr.name}, newWidth=${curr.newWidth}`) && all,
        [],
      );
      debugStr = `${debugStr}${debugStep}、第${
        tableIndex + 1
      }个表格: 循环完所有列之后，每列当前宽度为：<br/>${JSON.stringify(`${debugLoop.join(';<br/>')}`)}<br/>`;
      debugStr = getDebugStr({
        debugStr,
        flexTimeStart,
        adjustCol,
        debugStep,
        printStep,
        curPrintTableRef,
        onlyThTable,
        iFrameDcmt,
        LodopStrAryWidth,
        LODOP,
        targetWidth,
        itemStr,
        oldTableStr,
        directIndex,
        tableIndex,
        directTableMap,
        printTbWidth,
        splitAry,
        split0Ary,
      });
      debugStep++;
    }

    if (delta > 0) {
      // Todo 全部列都等比缩小
      colsOp(-delta, maxWidthConf.full.length);
    }

    for (const col of adjustCol) {
      if (maxWidthConf.full.includes(col.fieldName)) {
        handleFont(col);
      }
    }

    curPrintTableRef[0].style.whiteSpace = null;
    curPrintTableRef[0].style.tableLayout = 'fixed';
    curPrintTableRef[0].style.width = `${targetWidth}px`;
    adjustCol.forEach(col => (col.el.width = col.newWidth + +offSetPadding * 2)); // eslint-disable-line
    onlyThTable && onlyThTable.remove();

    if (!trNum) {
      curPrintTableRef[0].children[1].innerHTML = '';
    }
    let tableHtmlStr = curPrintTableRef[0].outerHTML;
    const totalTrSum = lastTrSum.cloneNode(true);

    const tfootStr = () => {
      // 每页小计处理函数
      let footHtmlStr = '';
      if (sumType === 'non-display-total' || !orderTbIndexAry.includes(tableIndex)) {
        return '';
      }
      for (const tdItemIndex in lastTrSum.children) {
        const tdItem = lastTrSum.children[tdItemIndex];
        const currTdTxt = tdItem.innerText;
        if (!isNaN(tdItemIndex)) {
          tdItem.innerText = +tdItemIndex === 0 ? '小计' : [...'#'.repeat(currTdTxt.length)].join('');
          const colTotalVal = totalTrSum.children[tdItemIndex].children[0].innerText || '';
          const colTotal1Val = colTotalVal.split('.')[1];
          const colDotLg = colTotal1Val ? colTotal1Val.length : 0;
          if (hasDot) {
            const formatStr = colDotLg ? `#,##0.${[...'#'.repeat(colDotLg)].join('')}` : '#,##0';
            // tdItem.format = formatStr
            tdItem.setAttribute('format', formatStr);
          }
        }
      }
      console.log('lastTrSum td', lastTrSum.children);
      if (['display-sub-total', 'display'].includes(sumType)) {
        footHtmlStr = `<tfoot tdata="subSum" >${lastTrSum.outerHTML}</tfoot>`;
      }
      return footHtmlStr;
    };

    // curPrintTableRef[0].style.display = null
    tableHtmlStr = tableHtmlStr.replace('</tbody>', `</tbody>${tfootStr()}`); // 每页小计的处理
    // tableHtmlStr = tableHtmlStr.replace('</table>', `</table>${totalSum()}`) // 末页合计的处理
    tableHtmlStr = tableHtmlStr.replace('display: none;', '');
    let itemHtmlStr = iFrameDcmt.body.innerHTML + tableHtmlStr;
    // 使用margin会导致数据串行，但padding不会，所以必须使用padding
    itemHtmlStr = itemHtmlStr.replace(
      /\.td-div{/g,
      `.th-div{padding:0 ${offSetPadding}px;font-weight:bold;letter-spacing:-1px;}.td-div{padding:0 ${offSetPadding}px;`,
    );

    // const shiftIndex = tableIndex === 0 ? 2 : 3
    // const nextTableTop = +directTableMap[directIndex + shiftIndex] || 5
    let nextTableTop = +directTableMap[tableIndex] || 5;
    if (directIndex <= No1NormalTbIndex || directIndex >= btm1ItemTypeIndex) {
      // 普通表格上方存在多个眉脚表格时，不用取眉脚表格之间的上边距
      nextTableTop = 5;
    }
    // 添加空白 div 遮挡超出边框的内容 start
    if (tableIndex !== 0) {
      const divWidth = Math.ceil((targetWidth / 96) * 25.4); // mm
      let divHtmlStr = `<div style="width:${divWidth}mm;height:${nextTableTop}px;background-color:#FFF;" ></div>`;
      divHtmlStr = `<!DOCTYPE html><html><head><meta http-equiv="content-type" content="text/html; charset="utf-8"><meta http-equiv="X-UA-Compatible" content="IE=edge" /><style>body{margin:0;padding:0;}</style></head><body>${divHtmlStr}</body></html>`;
      divHtmlStr = JSON.stringify(divHtmlStr);
      LodopStrAryWidth.push(`LODOP.ADD_PRINT_HTM(1,0,"${divWidth}mm","${nextTableTop}px",${divHtmlStr})`);

      LodopStrAryWidth.push('LODOP.SET_PRINT_STYLEA(0,"LinkedItem",-1)');
      LodopStrAryWidth.push('LODOP.SET_PRINT_STYLEA(0,"Vorient",3)');
    }
    /*
    普通表格上方存在眉脚表格时，添加的div没有相对位置
    if ((No1NormalTbIndex <= directIndex) && (directIndex <= btm1ItemTypeIndex)) {
      LodopStrAryWidth.push('LODOP.SET_PRINT_STYLEA(0,"LinkedItem",-1)')
      LodopStrAryWidth.push('LODOP.SET_PRINT_STYLEA(0,"Vorient",3)')
    }
    */
    // 添加空白 div 遮挡超出边框的内容 end

    itemHtmlStr = `<!DOCTYPE html><html><head><meta http-equiv="content-type" content="text/html; charset="utf-8"><meta http-equiv="X-UA-Compatible" content="IE=edge" /><style>body{margin:0;padding:0;}</style></head><body>${itemHtmlStr}</body></html>`;

    const totalSumPre = itemHtmlStr.split('<div></div>')[0]; // 合计表格需要使用当前运单表格的html样式
    const totalsumThead = curPrintTableRef[0].children[0].cloneNode(true);

    // 替换当前表格打印高度和上边距 start
    let newItemStr = itemStr;
    if (No1NormalTbIndex < directIndex && directIndex < btm1ItemTypeIndex) {
      // 第一个普通表格与最后一个普通表格之间的普通表格， 更改上边距
      const newTopDirect = `LODOP.ADD_PRINT_TABLE(0,${split0Ary[1]},${split0Ary[2]}`;
      newItemStr = `${newTopDirect}",${splitAry[1]}",${splitAry[2]}`;
    } else if (No1NormalTbIndex === directIndex) {
      // 第一个普通表格 ---> 更改表格可打印区域高度
      const buffHeight = ['display-sub-total', 'display'].includes(sumType) ? rowTrHeight : 0;
      // 每页小计不计入可打印区域高度； 末页合计是一个表格
      const tableLinkedH = No1TbBtm - No1TbTop - buffHeight;
      tableLinkedH && (newItemStr = `${splitAry[0]}",${tableLinkedH},${splitAry[2]}`);
    }
    // 替换当前表格打印高度和上边距 end

    itemHtmlStr = newItemStr.replace(oldTableStr, JSON.stringify(itemHtmlStr));
    // 用 ADD_PRINT_TABLE 添加DIv后遮不住超出边框的内容，可以解决不连续的问题
    // 因为ADD_PRINT_HTM指令下，定高后，表格实际高度可能要小于自然高度
    itemHtmlStr = itemHtmlStr.replace('ADD_PRINT_HTM', 'ADD_PRINT_TABLE');
    LodopStrAryWidth.push(itemHtmlStr);
    // LodopStrAryWidth.push('LODOP.SET_PRINT_STYLEA(0,"TableRowThickNess",32)')
    // 重新添加关联关系 start
    if (No1NormalTbIndex < directIndex && directIndex < btm1ItemTypeIndex) {
      LodopStrAryWidth.push('LODOP.SET_PRINT_STYLEA(0,"LinkedItem",-1);');
      LodopStrAryWidth.push('LODOP.SET_PRINT_STYLEA(0,"Vorient",3);');
    }
    // } else if (No1NormalTbIndex === directIndex) {
    //   LodopStrAryWidth.push('LODOP.SET_PRINT_STYLEA(0,"LinkedItem",1);')
    // }
    // 重新添加关联关系
    document.body.removeChild(natureIframeRef);

    if (['non-display', 'display', 'group-display'].includes(sumType) && orderTbIndexAry.includes(tableIndex)) {
      const totalTds = Array.from(totalTrSum.children);
      const widthThs = Array.from(totalsumThead.children[0].children);
      for (const tdIndex in totalTds) {
        // 将当前列的表头宽度赋值给合计表格tbody里面的单元格
        totalTds[tdIndex].width = widthThs[tdIndex].width;
      } // 合计表格不能有表头thead

      totalTrSum.firstElementChild.children[0].innerText = '合计';
      let totalHtmlStr = `${tableHtmlStr.split('<thead>')[0]}<tbody>${totalTrSum.outerHTML}</tbody></table>`;
      totalHtmlStr = `${totalSumPre}${totalHtmlStr}</body></html>`;
      totalHtmlStr = JSON.stringify(totalHtmlStr);
      const totalTbDirectStr = `LODOP.ADD_PRINT_TABLE(0,0,0,0,${totalHtmlStr})`;
      // 内容项与别人关联后，其Top和left不再是上边距和左边距，而是与关联项的间隔空隙及左边距偏移
      totalObj[tableIndex] = totalTbDirectStr;
      if (!LodopStrAry[directIndex + 1] || tableIndex + 1 === directTableMap.length) {
        LodopStrAryWidth.push(totalObj[tableIndex]);
        LodopStrAryWidth.push('LODOP.SET_PRINT_STYLEA(0,"LinkedItem",-1)');
        LodopStrAryWidth.push('LODOP.SET_PRINT_STYLEA(0,"Vorient",3)');
        totalObj[tableIndex - 1] = null;
      }
    }

    tableIndex++;
    console.log('new Date().getTime() - flexTimeStart', new Date().getTime() - flexTimeStart);

    return 'Hello';
  });

  if (debug) {
    debugFunc(debugStr);
    return false;
  }

  return LodopStrAryWidth.join(';');
}

function specialHandle(oldData) {
  // http://jira.chemanman.com/browse/CREQ-2016?filter=10616%A0
  // /Application/Ucmm/Service/TruckService.class.php  '临时支持永利达的需求'
  const newData = oldData;

  if ([260, 63138, 319].includes(+window.group_id)) {
    // 装车清单送货方式送货的显示一个送字，自提的不显示，像老系统一样
    const orderData = newData.order;
    const newOrderData = [];
    orderData &&
      orderData.forEach(item => {
        const currItem = { ...item };

        if (item.delivery_mode === '自提') {
          currItem.delivery_mode = '';
        }
        if (item.delivery_mode === '送货') {
          currItem.delivery_mode = '送';
        }

        if (item.arr) {
          // 63138
          // if (+item.arr_point === 28604 && item.arr_city === '北京市') {
          //   currItem.arr = ''
          // }
          if (+item.arr_point === 28605 && ['张家口市', '张家口'].includes(item.arr)) {
            currItem.arr = '';
          }
          if (+item.arr_point === 28606 && ['宣化区', '宣化', '宣化市'].includes(item.arr)) {
            currItem.arr = '';
          }
          // 260
          if (+item.arr_point === 15123 && item.arr === '厦门市') {
            currItem.arr = '';
          }
          // 319
          if (+item.arr_point === 11166 && item.arr === '菏泽市') {
            currItem.arr = '';
          }
        }

        newOrderData.push(currItem);
      });
    orderData && (newData.order = newOrderData);
  }
  console.log('specialHandle oldData', oldData);
  return newData;
}

function parseUntdTableData(data, printSetting, tplStr) {
  parsePrintData(data, printSetting);
  const lineHeight = printSetting.table_height || 18; // 因为之前默认是18
  const fontSize = printSetting.table_font_size || 12;
  // 替换行高 跟字体
  const intTplStr = tplStr.replace(
    /<\/style>/g,
    `table,td,th{line-height:${lineHeight}px;font-size:${fontSize}px;}</style>`,
  ); // eslint-disable-line no-eval
  // const intTplStr = tplStr.replace(/<\/style>/g, `table,td,th{font-size:${fontSize}px;}</style>`)   // eslint-disable-line no-eval
  // 如果是纵向，需要将table的宽度替换掉
  // if (printSetting.direction === 'vertical') { // 纵向打印
  //   intTplStr = intTplStr.replace(/<\/style>/g, `table{width:${printSetting.width - 3}mm}</style>`)
  // } else if (printSetting.direction === 'horizontal') { // 横向打印
  // }
  // intTplStr = intTplStr.replace(/<\/style>/g, `table{width:${printSetting.height - 3}mm}</style>`)
  const tplArr = intTplStr.split('LODOP.');
  // 需要为包含order的打印语句重新生成数据
  // let fontSize = printSetting.font_size ? printSetting.font_size : 12
  const totalOrderLen = data.order.length;
  const totalStationLen = data.p_station && data.p_station.length > 0 ? data.p_station.length : 0;
  const totalaApprovalLen = data.approval && data.approval.length > 0 ? data.approval.length : 0;
  const totalfeeApprovalGgLen =
    data.fee_approval_agg && data.fee_approval_agg.length > 0 ? data.fee_approval_agg.length : 0;
  const driverTrNumLen = data.driver_tr_num && data.driver_tr_num.length > 0 ? data.driver_tr_num.length : 0;
  const payModeLen = data.pay_mode && data.pay_mode.length > 0 ? data.pay_mode.length : 0;
  const totalaApprovalFeeLen = data.fee_approval && data.fee_approval.length > 0 ? data.fee_approval.length : 0;
  const newTplArr = [];
  let tplCount = 1;

  // let textBlock = (printSetting.text_block === 'block') || false  // 判断是否换行 默认换行
  for (let tpl of tplArr) {
    if (!tpl) {
      continue; // eslint-disable-line no-continue
    }
    if (tpl.indexOf('ADD_PRINT_HTM') !== false && tpl.indexOf('ADD_PRINT_HTM') >= 0) {
      // 提取html的内容
      const tmpTplStatement = tpl.split('<style>');
      let tplHtml = tmpTplStatement[1];
      tplHtml = tplHtml.substring(0, tplHtml.length - 3);
      tplHtml = `<style>${tplHtml}`;
      const tmpTplHtml = tplHtml;
      const currTBody = tplHtml.substring(tplHtml.indexOf('<tbody>') + 7, tplHtml.indexOf('</tbody>'));
      if (/order\./.test(tplHtml)) {
        // 有order数据的时候需要循环生成数据
        // 提取tbody中的那段代码， 需要将所有的tbody中的order.替换为对应的index的order数据
        // tplHtml = tplHtml.replace(currTBody, '')
        // if (totalOrderLen <= 0) {
        //   continue // eslint-disable-line no-continue
        // }
        const newTplHtml = [];
        for (let i = 0; i < totalOrderLen; ++i) {
          let newTBody = currTBody.replace(/order\./g, `order[${i}].`);
          newTBody = newTBody.replace(/<tr/, `<tr style='line-height:${lineHeight}px;font-size:${fontSize}px;'`);
          newTBody = newTBody.replace(/"/g, '\\"');
          newTBody = format(newTBody);
          // newTBody = newTBody.replace(/<td/g, '<td><div')
          // newTBody = newTBody.replace(/<\/td/g, '</div></td')
          newTplHtml.push(newTBody);
        }
        const replaceMeStr = '%REPLACE_ME_HEAR%';
        tpl = tpl.replace(currTBody, replaceMeStr);
        // !textBlock && (tpl = tpl.replace(/<style>/, '<style>table{display:fixed;}table td{flex:1;min-width:0;}table td div{white-space:nowrap;overflow:hidden;text-overflow:ellipsis;}'))
        tpl = format(tpl.replace(/"/g, '\\"'));
        let newTplStr = tpl.replace(replaceMeStr, newTplHtml.join(''));
        // newTplStr = newTplStr.replace(/"/g, '\\"')
        newTplStr = newTplStr.replace('ADD_PRINT_HTM', 'ADD_PRINT_TABLE');
        newTplArr.push(`LODOP.${newTplStr}`);
      } else if (/p_station\./.test(tplHtml)) {
        // 有p_station数据的时候需要循环生成数据
        const newTplHtml = [];
        for (let i = 0; i < totalStationLen; ++i) {
          let newTBody = currTBody.replace(/p_station\./g, `p_station[${i}].`);
          newTBody = newTBody.replace(/<tr/, `<tr style='line-height:${lineHeight}px;font-size:${fontSize}px;'`);
          newTBody = newTBody.replace(/"/g, '\\"');
          newTBody = format(newTBody);
          newTplHtml.push(newTBody);
        }
        const replaceMeStr = '%REPLACE_ME_HEAR%';
        tpl = tpl.replace(currTBody, replaceMeStr);
        tpl = format(tpl.replace(/"/g, '\\"'));
        let newTplStr = tpl.replace(replaceMeStr, newTplHtml.join(''));
        newTplStr = newTplStr.replace('ADD_PRINT_HTM', 'ADD_PRINT_TABLE');
        newTplArr.push(`LODOP.${newTplStr}`);
      } else if (/fee_approval\./.test(tplHtml)) {
        // 有fee_approval数据的时候需要循环生成数据
        const newTplHtml = [];
        for (let i = 0; i < totalaApprovalFeeLen; ++i) {
          let newTBody = currTBody.replace(/fee_approval\./g, `fee_approval[${i}].`);
          newTBody = newTBody.replace(/<tr/, `<tr style='line-height:${lineHeight}px;font-size:${fontSize}px;'`);
          newTBody = newTBody.replace(/"/g, '\\"');
          newTBody = format(newTBody);
          newTplHtml.push(newTBody);
        }
        const replaceMeStr = '%REPLACE_ME_HEAR%';
        tpl = tpl.replace(currTBody, replaceMeStr);
        tpl = format(tpl.replace(/"/g, '\\"'));
        let newTplStr = tpl.replace(replaceMeStr, newTplHtml.join(''));
        newTplStr = newTplStr.replace('ADD_PRINT_HTM', 'ADD_PRINT_TABLE');
        newTplArr.push(`LODOP.${newTplStr}`);
      } else if (/approval\./.test(tplHtml)) {
        // 有approval数据的时候需要循环生成数据
        const newTplHtml = [];
        for (let i = 0; i < totalaApprovalLen; ++i) {
          let newTBody = currTBody.replace(/approval\./g, `approval[${i}].`);
          newTBody = newTBody.replace(/<tr/, `<tr style='line-height:${lineHeight}px;font-size:${fontSize}px;'`);
          newTBody = newTBody.replace(/"/g, '\\"');
          newTBody = format(newTBody);
          newTplHtml.push(newTBody);
        }
        const replaceMeStr = '%REPLACE_ME_HEAR%';
        tpl = tpl.replace(currTBody, replaceMeStr);
        tpl = format(tpl.replace(/"/g, '\\"'));
        let newTplStr = tpl.replace(replaceMeStr, newTplHtml.join(''));
        newTplStr = newTplStr.replace('ADD_PRINT_HTM', 'ADD_PRINT_TABLE');
        newTplArr.push(`LODOP.${newTplStr}`);
      } else if (/pay_mode\./.test(tplHtml)) {
        // 有approval数据的时候需要循环生成数据
        const newTplHtml = [];
        for (let i = 0; i < payModeLen; ++i) {
          let newTBody = currTBody.replace(/pay_mode\./g, `pay_mode[${i}].`);
          newTBody = newTBody.replace(/<tr/, `<tr style='line-height:${lineHeight}px;font-size:${fontSize}px;'`);
          newTBody = newTBody.replace(/"/g, '\\"');
          newTBody = format(newTBody);
          newTplHtml.push(newTBody);
        }
        const replaceMeStr = '%REPLACE_ME_HEAR%';
        tpl = tpl.replace(currTBody, replaceMeStr);
        tpl = format(tpl.replace(/"/g, '\\"'));
        let newTplStr = tpl.replace(replaceMeStr, newTplHtml.join(''));
        newTplStr = newTplStr.replace('ADD_PRINT_HTM', 'ADD_PRINT_TABLE');
        newTplArr.push(`LODOP.${newTplStr}`);
      } else if (/driver_tr_num\./.test(tplHtml)) {
        // 有approval数据的时候需要循环生成数据
        const newTplHtml = [];
        for (let i = 0; i < driverTrNumLen; ++i) {
          let newTBody = currTBody.replace(/driver_tr_num\./g, `driver_tr_num[${i}].`);
          newTBody = newTBody.replace(/<tr/, `<tr style='line-height:${lineHeight}px;font-size:${fontSize}px;'`);
          newTBody = newTBody.replace(/"/g, '\\"');
          newTBody = format(newTBody);
          newTplHtml.push(newTBody);
        }
        const replaceMeStr = '%REPLACE_ME_HEAR%';
        tpl = tpl.replace(currTBody, replaceMeStr);
        tpl = format(tpl.replace(/"/g, '\\"'));
        let newTplStr = tpl.replace(replaceMeStr, newTplHtml.join(''));
        newTplStr = newTplStr.replace('ADD_PRINT_HTM', 'ADD_PRINT_TABLE');
        newTplArr.push(`LODOP.${newTplStr}`);
      } else if (/fee_approval_agg\./.test(tplHtml)) {
        // 有approval数据的时候需要循环生成数据
        const newTplHtml = [];
        for (let i = 0; i < totalfeeApprovalGgLen; ++i) {
          let newTBody = currTBody.replace(/fee_approval_agg\./g, `fee_approval_agg[${i}].`);
          newTBody = newTBody.replace(/<tr/, `<tr style='line-height:${lineHeight}px;font-size:${fontSize}px;'`);
          newTBody = newTBody.replace(/"/g, '\\"');
          newTBody = format(newTBody);
          newTplHtml.push(newTBody);
        }
        const replaceMeStr = '%REPLACE_ME_HEAR%';
        tpl = tpl.replace(currTBody, replaceMeStr);
        tpl = format(tpl.replace(/"/g, '\\"'));
        let newTplStr = tpl.replace(replaceMeStr, newTplHtml.join(''));
        newTplStr = newTplStr.replace('ADD_PRINT_HTM', 'ADD_PRINT_TABLE');
        newTplArr.push(`LODOP.${newTplStr}`);
      } else if (/onway_\w+\./.test(tplHtml)) {
        // 往返运单-在途费用
        const newTplHtml = [];
        const key = tplHtml.match(/onway_\w+\./g)[0].slice(0, -1);
        for (let i = 0; i < data?.[key]?.length; ++i) {
          let newTBody = currTBody.replace(/onway_\w+\./g, match => {
            return `${match.slice(0, -1)}[${i}].`;
          });
          newTBody = newTBody.replace(/<tr/, `<tr style='line-height:${lineHeight}px;font-size:${fontSize}px;'`);
          newTBody = newTBody.replace(/"/g, '\\"');
          newTBody = format(newTBody);
          newTplHtml.push(newTBody);
        }
        const replaceMeStr = '%REPLACE_ME_HEAR%';
        tpl = tpl.replace(currTBody, replaceMeStr);
        tpl = format(tpl.replace(/"/g, '\\"'));
        let newTplStr = tpl.replace(replaceMeStr, newTplHtml.join(''));
        newTplStr = newTplStr.replace('ADD_PRINT_HTM', 'ADD_PRINT_TABLE');
        newTplArr.push(`LODOP.${newTplStr}`);
      } else {
        tplHtml = tplHtml.replace(/<tr>/g, `<tr style='line-height:${lineHeight}px;font-size:${fontSize}px;'>`);
        tplHtml = tplHtml.replace(/"/g, '\\"');
        tpl = tpl.replace(tmpTplHtml, tplHtml);
        // !textBlock && (tpl = tpl.replace(/<style>/, '<style>table{display:fixed;}table tbody td{white-space: nowrap;overflow: hidden;text-overflow: ellipsis;}'))
        tpl = format(tpl);
        newTplArr.push(`LODOP.${tpl}`);
      }
    } else {
      // 自定义打印的非套打表头
      tpl = format(tpl);
      newTplArr.push(`LODOP.${tpl}`);
    }
    if (printSetting.flex_type !== 'complex') {
      if (tpl.includes('ADD_PRINT_HTM') || tpl.includes('ADD_PRINT_TABLE')) {
        if (tplCount++ === 1) {
          newTplArr.push('LODOP.SET_PRINT_STYLEA(0,"LinkedItem",1);');
        } else {
          newTplArr.push('LODOP.SET_PRINT_STYLEA(0,"LinkedItem",-1);');
          newTplArr.push('LODOP.SET_PRINT_STYLEA(0,"Vorient",3);');
        }
      }
    }
  }
  return newTplArr;
}

export function untdTablePreview(LODOP, data, printSetting) {
  const tplStr = LODOP.GET_VALUE('ProgramCodes', 0);
  const newTplArr = parseUntdTableData(data, printSetting, tplStr);
  for (const tpl of newTplArr) {
    eval(`${tpl};`); // eslint-disable-line no-eval
  }
  LODOP?.SET_SHOW_MODE?.('DESIGN_IN_BROWSER', 1);
  LODOP.SET_PRINT_MODE('PROGRAM_CONTENT_BYVAR', true);
  LODOP.PRINT_DESIGN();
}

export async function untdTablePrint(proxy) {
  const { LODOP, data, printSetting, tplDetail, needCheck, isRetry, dataSum = 1 } = proxy;
  window.loadPrintTimeStart = new Date().getTime();

  !needCheck && !isRetry && (window.PRINTERRORSTEP = 1);
  const checkResult = await printWait(LODOP, needCheck, printSetting);
  console.log('print --->  checkResult', checkResult);
  if (checkResult !== 1) {
    const correctResult = await printFaultCorrect(checkResult, printSetting);
    const printSettingNext = typeof correctResult === 'object' ? { ...printSetting, ...correctResult } : printSetting;

    const printProxy = {
      LODOP: window.globalLodopObj,
      data,
      printSetting: printSettingNext,
      tplDetail,
      needCheck: false,
      isRetry: true,
      dataSum,
    };
    correctResult && untdTablePrint(printProxy);
    return;
  }

  let newTplStr = tplDetail;
  const printData = specialHandle(data);
  const newTplArr = parseUntdTableData(printData, printSetting, newTplStr);
  if (printSetting && printSetting.width && printSetting.height) {
    newTplStr = parseTablePrintSetting(LODOP, printSetting, newTplArr.join(';'));
  }
  // jsscript改为处理数据脚本 2022-12-14
  // if (printSetting.jsscript) {
  //   newTplStr = eval(printSetting.jsscript); // eslint-disable-line no-eval
  // }

  printSetting.flex_type === 'complex' && (newTplStr = v1FlexWidth(LODOP, newTplStr, printSetting, tplDetail));
  // newTplStr = v1FlexWidth(LODOP, newTplStr, printSetting, tplDetail)

  if (window.location.href.includes('debug=true')) {
    return false;
  }

  eval(newTplStr); // eslint-disable-line no-eval

  // LODOP.SET_PRINT_MODE('PROGRAM_CONTENT_BYVAR', true)
  // 如果选择了打印机，需要重新设置打印机，否则使用默认的打印机
  if (printSetting && printSetting.printer) {
    const printerCount = LODOP.GET_PRINTER_COUNT();
    for (let i = 0; i < printerCount; ++i) {
      const printerName = LODOP.GET_PRINTER_NAME(i);
      if (printerName === printSetting.printer) {
        LODOP.SET_PRINTER_INDEXA(printerName);
      }
    }
  }
  const printCopies = printSetting.print_copies ? printSetting.print_copies : 1;
  LODOP.SET_PRINT_COPIES(printCopies);

  const popPreview = isPreview({ printSetting, dataSum });
  popPreview ? LODOP.PREVIEW() : printStatusCommand(LODOP, proxy, PRINT_TYPE.TABLE_BILL);

  // LODOP.PRINT_DESIGN()
  console.log('loadPrintTimeStart = ', new Date().getTime() - window.loadPrintTimeStart);
}

export async function printContract(LODOP, printSetting, needCheck, isRetry, divId) {
  !needCheck && !isRetry && (window.PRINTERRORSTEP = 1);

  const checkResult = await printWait(LODOP, needCheck, printSetting);
  console.log('print --->  checkResult', checkResult);
  if (checkResult !== 1) {
    const correctResult = await printFaultCorrect(checkResult, printSetting);
    const printSettingNext = typeof correctResult === 'object' ? { ...printSetting, ...correctResult } : printSetting;
    correctResult && printContract(window.globalLodopObj, printSettingNext, false, true, divId);
    return;
  }

  const topDistance = printSetting && printSetting.margin_top ? printSetting.margin_top : 0;
  const leftDistance = printSetting && printSetting.margin_left ? printSetting.margin_left : 0;
  const paperWidth = printSetting && printSetting.width ? printSetting.width : 200;
  const paperHeight = printSetting && printSetting.height ? printSetting.height : 280;
  LODOP.PRINT_INITA(`${topDistance}mm`, `${leftDistance}mm`, `${paperWidth}mm`, `${paperHeight}mm`, '打印运输合同');
  LODOP.SET_PRINT_PAGESIZE(1, 0, 0, 'A4');
  LODOP.SET_PRINT_STYLEA(0, 'ItemType', 1);
  LODOP.SET_PRINT_STYLEA(0, 'FontSize', 9);
  LODOP.SET_PRINT_STYLEA(0, 'FontColor', '#999999');
  LODOP.SET_PRINT_STYLEA(0, 'Alignment', 3);
  const strStyle =
    '<style>body{padding-right:10px;}em{font-style:normal;}.in-bk{display:inline-block;}p{margin:0;padding:0;}.fn-input,.ant-input{font-family:inherit;border:1px solid #000;height:16px;font-size:14px;background:#fff;padding:3px 5px;border-radius:2px;color:#000;cursor:text;line-height:18px;display:inline-block;}.fn-input[disabled],.ant-input[disabled]{background-color:#fff !important;border-color:#000 !important;cursor:no-drop;}.batch-contract__main > div,.batch-contract__main > p{position:relative;padding-left:34px;margin-left:26px;}.batch-contract__main > div em,.batch-contract__main > p em{position:absolute;width:44px;left:-5px;top:0;}.batch-contract__wrap{background-color:#fff;position:relative;padding:0 40px;height:100%;font-size:14px;}.batch-contract__control{width:214px;position:absolute;height:60px;top:10px;right:50px;}.batch-contract__title{font-weight:bold;padding:0 0 10px;font-size:20px;color:#0f0f0f;line-height:20px;text-align:center;position:relative;width:100%;overflow:hidden;}.batch-contract__title h3{margin:0;padding:0;}.batch-contract__title span{float:left;height:33px;line-height:33px;}.batch-contract__main{padding-right:40px;}.batch-contract__main p{line-height:22px;position:relative;padding-left:34px;}.batch-contract__main p.padd0{padding-left:0;}.batch-contract__main .fn-table{margin-top:5px;margin-bottom:5px;}table th,table td{border:1px solid #000;}.batch-contract__main div input{border-bottom:1px solid #000;border-left:none;border-right:none;border-top:none;background:none;}.baseInput__w{display:inline-block;vertical-align:middle;}.batch-contract__remark_text{float:left}.batch-contract__number{float:right;padding-right:30px;}.batch-contract__number .fn-input{border:0 none;font-size:16px;line-height: 30px;height:30px;width:200px;}.fn-input-wrap{display:inline-block;position:relative;}.fn-table{border-collapse:collapse;border-spacing:0;margin-left:20px;margin-right:20px;width:99%;}.fn-table td,.fn-table th{min-width:40px;border:1px solid #000;text-align:center;font-size:14px;}.fn-table td{padding:4px 5px}.fn-table thead th{height:24px;background-color:#fff;white-space:nowrap}.fn-table tbody td{max-width:300px;text-align:left; height: 19px;}.batch-contract__main .fn-table2 tr td:nth-child(2n+1){background:#F7F7F7;color:#333;font-size:12px;font-weight:bold;}.batch-contract__main p,.batch-contract__main div,.batch-contract__main .fn-input{font-size:14px;line-height:26px;}.batch-contract__main .fn-input{width:180px;}.batch-contract__main .inp{line-height: 22px; height: 22px;display: inline-block;border-bottom: 1px solid #000;padding: 0 5px;min-width: 140px;vertical-align: bottom;}.batch-contract__main .long-inp{min-width:240px;}.contract__main div{line-height: 22px;}.batch-contract__remark_hidden{display:block;min-height:50px;}.batch-contract__remark{display:none;overflow:hidden;}.batch-contract__remark span{}.batch-contract__button{display:none;}.fn-textarea{background:transparent;border:0 none;overflow:visible;}.batch-contract__main > div{overflow:hidden;width:96%;}.batch-contract__main > div p{float:left;}.ftk{line-height:22px;}.eigh{width:100%;overflow:hidden;}.eigh .fn-input{width:60px;}.sign-table{font-size:14px;margin-left:60px;margin-top:1px;border-spacing:0;width:650px;border-collapse:collapse;}.sign-table th, .sign-table td{border:none;line-height:15px;}.fn-table tbody td div{line-height:16px;}</style>';
  const innerHtml = document.getElementById(`contractContent_${divId}`).innerHTML;
  const signHtml =
    '<table class="sign-table"><tr><td>甲方签字：</td><td>乙方签字：</td></tr><tr><td>签字日期：</td><td>签字日期：</td></tr></table>';
  LODOP.ADD_PRINT_HTM(
    34,
    '2px',
    0,
    'BottomMargin:5mm',
    `<!DOCTYPE html><head><meta http-equiv="X-UA-Compatible" content="edge" />${strStyle}</head><body>${innerHtml}${signHtml}`,
  );
  LODOP.SET_PRINT_STYLEA(0, 'LinkedItem', 4);
  LODOP.SET_PRINT_STYLEA(0, 'Vorient', 3);
  // LODOP.ADD_PRINT_HTM(0, '2px', 0, 'BottomMargin:30mm', `${signStyle}${signHtml}</body></html>`)
  // LODOP.SET_PRINT_STYLEA(0, 'PageIndex', 'last')
  // LODOP.SET_PRINT_STYLEA(0, 'LinkedItem', 1)
  // // LODOP.SET_PRINT_STYLEA(0, 'LinkNewPage', true)
  // LODOP.SET_PRINT_STYLEA(0, 'Vorient', 3)
  // LODOP.NewPageA()
  const { printer } = printSetting;
  if (printer && LODOP.SET_PRINTER_INDEXA(printer)) {
    LODOP.PRINT();
  }
}

function parseTagData(data) {
  let totalCount = 0;
  window.lodopCustomVars = window.lodopCustomVars || {};
  const orderData = [];
  data.forEach(item => {
    // 标签需要打印多少份就需要复制多少数据
    const printCopies = item.printCopies || item.num; // 标签打印份数
    const startIndex = item.startIndex || 1; // 标签起始打印位置
    for (let i = startIndex; i <= printCopies; ++i) {
      const tplDataCopy = Object.assign({}, item);
      tplDataCopy.qr_code_serial = tplDataCopy.qr_code_serial ? `${tplDataCopy.qr_code_serial}-${i}` : '';
      tplDataCopy.order_num_bar_code_serial = tplDataCopy.order_num_bar_code_serial
        ? `${tplDataCopy.order_num_bar_code_serial}-${i}`
        : '';
      tplDataCopy.qr_code_bar_code_serial = tplDataCopy.qr_code_bar_code_serial
        ? `${tplDataCopy.qr_code_bar_code_serial}-${i}`
        : '';
      tplDataCopy.tag_serial_num = i;
      tplDataCopy.tag_total_count = item.tagTotalCount || printCopies;

      const ori_custom_good_sn = tplDataCopy.custom_good_sn;
      if (ori_custom_good_sn) {
        const custom_good_sn_val = Array.isArray(ori_custom_good_sn) ? ori_custom_good_sn : [];
        tplDataCopy.custom_good_sn = custom_good_sn_val[i - 1];
      }
      orderData.push(tplDataCopy);
      ++totalCount;
    }
  });
  window.lodopCustomVars = {
    order: orderData,
  };
  return totalCount;
}

export async function printMultipleTags(LODOP, data, printSetting, tplDetail, needCheck, isRetry) {
  !needCheck && !isRetry && (window.PRINTERRORSTEP = 1);

  const checkResult = await printWait(LODOP, needCheck, printSetting);
  console.log('print --->  checkResult', checkResult);
  if (checkResult !== 1) {
    const correctResult = await printFaultCorrect(checkResult, printSetting);
    const printSettingNext = typeof correctResult === 'object' ? { ...printSetting, ...correctResult } : printSetting;
    correctResult && printMultipleTags(window.globalLodopObj, data, printSettingNext, tplDetail, false, true);
    return;
  }

  parseTagData(data);
  let startIndex = +printSetting.startIndex;
  const rowCount = printSetting.row_count;
  const columnCount = printSetting.column_count;
  const printCount = +printSetting.printCount;
  const countPerPage = +(rowCount * columnCount);
  const perLeft = printSetting.width;
  const perTop = printSetting.height;
  const paperWidth = perLeft * columnCount;
  const paperHeight = perTop * rowCount;
  // 计算总页数
  let pageCount = Math.ceil((printCount - countPerPage + startIndex) / countPerPage) + 1;
  // 生成每页的模板
  const allTpl = [];
  // 生成每个位置的左位移和上位移
  const allTplMargin = [];
  for (let i = 0; i < rowCount; ++i) {
    for (let j = 0; j < columnCount; ++j) {
      allTplMargin.push({
        left: j * perLeft,
        top: i * perTop,
      });
    }
  }

  const modifyTplDetail = tplDetail;
  // jsscript改为处理数据脚本 2022-12-14
  // if (printSetting.jsscript) {
  //   modifyTplDetail = eval(printSetting.jsscript); // eslint-disable-line no-eval
  // }

  const tplList = modifyTplDetail.split(';');
  // 生成每一页的模板
  let totalCount = 0;
  if (pageCount < 0) {
    pageCount = 1;
  }
  let currCount = 0;
  while (pageCount > 0) {
    // 抽取模板的左边距和上边距，重新计算位置，都加上相对位移
    for (let k = startIndex - 1; totalCount < printCount; ++k) {
      const currTplArr = [];
      for (let tpl of tplList) {
        if (
          (tpl.indexOf('ADD_PRINT_TEXT') !== false && tpl.indexOf('ADD_PRINT_TEXT') >= 0) ||
          (tpl.indexOf('ADD_PRINT_BARCODEA') !== false && tpl.indexOf('ADD_PRINT_BARCODEA') >= 0) ||
          (tpl.indexOf('ADD_PRINT_IMAGE') !== false && tpl.indexOf('ADD_PRINT_IMAGE') >= 0) ||
          (tpl.indexOf('ADD_PRINT_HTM') !== false && tpl.indexOf('ADD_PRINT_HTM') >= 0) ||
          (tpl.indexOf('ADD_PRINT_RECT') !== false && tpl.indexOf('ADD_PRINT_RECT') >= 0)
        ) {
          const replaceHeight = parseInt(allTplMargin[k].top * 3.78, 0);
          const replaceLeft = parseInt(allTplMargin[k].left * 3.78, 0);
          const margin = tpl.match(/(\d+),(\d+)/gi)[0];
          const marginArr = margin.split(',');
          let marginTop = marginArr[0];
          let marginLeft = marginArr[1];
          marginTop = parseInt(marginTop, 0) + replaceHeight;
          marginLeft = parseInt(marginLeft, 0) + replaceLeft;
          tpl = tpl.replace(/(\d+),(\d+)/i, `${marginTop},$2`);
          tpl = tpl.replace(/(\d+),(\d+)/i, `$1,${marginLeft}`);
          // 替换模板高度
          currTplArr.push(tpl);
        } else if (tpl.indexOf('ADD_PRINT_LINE') !== false && tpl.indexOf('ADD_PRINT_LINE') >= 0) {
          const replaceHeight = parseInt(allTplMargin[k].top * 3.78, 0);
          const replaceLeft = parseInt(allTplMargin[k].left * 3.78, 0);
          const margin = tpl.match(/(\d+),(\d+),(\d+),(\d+)/gi)[0];
          const marginArr = margin.split(',');
          let marginTopStart = marginArr[0];
          let marginLeftStart = marginArr[1];
          let marginTopEnd = marginArr[2];
          let marginLeftEnd = marginArr[3];
          marginTopStart = parseInt(marginTopStart, 0) + replaceHeight;
          marginLeftStart = parseInt(marginLeftStart, 0) + replaceLeft;
          marginTopEnd = parseInt(marginTopEnd, 0) + replaceHeight;
          marginLeftEnd = parseInt(marginLeftEnd, 0) + replaceLeft;
          tpl = tpl.replace(
            /(\d+),(\d+),(\d+),(\d+)/i,
            `${marginTopStart},${marginLeftStart},${marginTopEnd},${marginLeftEnd}`,
          );
          // 替换模板高度
          currTplArr.push(tpl);
        } else {
          currTplArr.push(tpl);
        }
      }
      const currTplStr = currTplArr.join(';').replace(/lodopCustomVars\./g, `lodopCustomVars.order[${currCount}].`);
      allTpl.push(currTplStr);
      ++totalCount;
      ++startIndex;
      ++currCount;
      if (startIndex > countPerPage) {
        break;
      }
    }
    allTpl.push('LODOP.NewPage()');
    startIndex = 1; // 第二页往后都从第一个位置开始打印
    --pageCount;
  }
  let newTplStr = allTpl.join(';');
  const newPrintSetting = printSetting;
  newPrintSetting.width = paperHeight;
  newPrintSetting.height = paperWidth;
  if (newPrintSetting && newPrintSetting.width && newPrintSetting.height) {
    newTplStr = parseTablePrintSetting(LODOP, newPrintSetting, newTplStr);
  }

  eval(newTplStr); // eslint-disable-line no-eval
  LODOP.SET_PRINT_MODE('PROGRAM_CONTENT_BYVAR', true);
  // 如果选择了打印机，需要重新设置打印机，否则使用默认的打印机
  if (printSetting && printSetting.printer) {
    const printerCount = LODOP.GET_PRINTER_COUNT();
    for (let i = 0; i < printerCount; ++i) {
      const printerName = LODOP.GET_PRINTER_NAME(i);
      if (printerName === printSetting.printer) {
        LODOP.SET_PRINTER_INDEXA(printerName);
      }
    }
  }
  LODOP.PRINT();
  printLog(data, printSetting, printCount);
}

export async function printTags(LODOP, data, printSetting, tplDetail, needCheck, isRetry) {
  !needCheck && !isRetry && (window.PRINTERRORSTEP = 1);
  const checkResult = await printWait(LODOP, needCheck, printSetting);
  console.log('print --->  checkResult', checkResult);
  if (checkResult !== 1) {
    const correctResult = await printFaultCorrect(checkResult, printSetting);
    const printSettingNext = typeof correctResult === 'object' ? { ...printSetting, ...correctResult } : printSetting;
    correctResult && printTags(window.globalLodopObj, data, printSettingNext, tplDetail, false, true);
    return;
  }

  let allCount = 0;

  const modifyTplDetail = tplDetail;
  // jsscript改为处理数据脚本 2022-12-14
  // if (printSetting.jsscript) {
  //   modifyTplDetail = eval(printSetting.jsscript); // eslint-disable-line no-eval
  // }

  const subPrintTags = itemData => {
    console.log('subPrintTags');
    // eslint-disable-next-line no-async-promise-executor
    return new Promise(async resolve => {
      const totalCount = parseTagData([itemData]);
      // 需要重新生成模板高度
      if (printSetting && printSetting.width && printSetting.height) {
        parsePrintSetting(LODOP, printSetting, '');
      }
      // 根据totalCount重新生成模板
      for (let i = 0; i < totalCount; ++i) {
        const originTpl = modifyTplDetail.replace(/lodopCustomVars\./g, `lodopCustomVars.order[${i}].`);
        const tplList = [];
        tplList.push(originTpl);
        tplList.push('LODOP.NewPageA()');
        eval(tplList.join(';')); // eslint-disable-line no-eval
      }
      LODOP.SET_PRINT_MODE('PROGRAM_CONTENT_BYVAR', true);
      // 如果选择了打印机，需要重新设置打印机，否则使用默认的打印机
      if (printSetting && printSetting.printer) {
        const printerCount = LODOP.GET_PRINTER_COUNT();
        for (let i = 0; i < printerCount; ++i) {
          const printerName = LODOP.GET_PRINTER_NAME(i);
          if (printerName === printSetting.printer) {
            LODOP.SET_PRINTER_INDEXA(printerName);
          }
        }
      }
      LODOP.PRINT();
      resolve(true);
    });
  };

  const perNum = 100;
  data.forEach(async item => {
    const virCurrRowTotalNum = +item.printCopies || +item.num; // 该标签总的打印份数
    const startIndex = +item.startIndex || 0;
    const currRowTotalNum = virCurrRowTotalNum - startIndex; // 下表从0开始的index的总数

    // const currRowTotalNum = +item.printCopies || +item.num   // 该标签总的打印份数
    const subCountInit = Math.floor(currRowTotalNum / perNum); // 共需要分成几份中的整数份
    const lastNum = currRowTotalNum - perNum * subCountInit;

    //  virCurrRowTotalNum - (+item.startIndex - 1)
    allCount += currRowTotalNum + 1; // bugID=40173

    for (let i = 0; i < subCountInit; i++) {
      const newStartIndex = startIndex + i * perNum;
      const currSubNum = perNum + newStartIndex - 1;
      const newItemData = {
        ...item,
        printCopies: currSubNum,
        startIndex: newStartIndex,
        tagTotalCount: virCurrRowTotalNum,
      }; // 43292
      await subPrintTags(newItemData);
    }
    const lastStartIndex = startIndex + subCountInit * perNum;
    const lastCountNum = lastNum + lastStartIndex;
    const lastCountData = { ...item, printCopies: lastCountNum, startIndex: lastStartIndex };
    await subPrintTags(lastCountData);
  });
  printLog(data, printSetting, allCount);
}

export function deletePrint(LODOP, index) {
  const systemVar = `LODOP.SET_PRINT_STYLEA(${index},'Deleted',true);`;
  eval(systemVar); // eslint-disable-line no-eval
  return systemVar;
}
// 图片打印
export async function printImgFile(proxy) {
  const { LODOP, basePath, printSetting } = proxy;
  LODOP.PRINT_INIT('打印控件_打印图片');
  if (printSetting && printSetting.printer) {
    const printerCount = LODOP.GET_PRINTER_COUNT();
    for (let i = 0; i < printerCount; ++i) {
      const printerName = LODOP.GET_PRINTER_NAME(i);
      if (printerName === printSetting.printer) {
        LODOP.SET_PRINTER_INDEXA(printerName);
        break;
      }
    }
  }
  // 默认a4纸大小
  const { width = 210, height = 297 } = printSetting;
  LODOP.ADD_PRINT_IMAGE(30, 20, `${width - 15}mm`, `${height - 20}mm`, `<img border='0' src='${basePath}' />`);
  LODOP.SET_PRINT_STYLEA(0, 'Stretch', 2);
  printStatusCommand(LODOP, proxy, PRINT_TYPE.ATTACHMENT);
}
// PDF打印
export async function printPdfFile(proxy) {
  const { LODOP, printSetting, basePath } = proxy;
  LODOP.PRINT_INIT('打印控件_打印PDF');
  if (printSetting && printSetting.printer) {
    const printerCount = LODOP.GET_PRINTER_COUNT();
    for (let i = 0; i < printerCount; ++i) {
      const printerName = LODOP.GET_PRINTER_NAME(i);
      if (printerName === printSetting.printer) {
        LODOP.SET_PRINTER_INDEXA(printerName);
        break;
      }
    }
  }
  LODOP.ADD_PRINT_PDF(0, 0, '100%', '100%', downloadPDF(basePath));
  printStatusCommand(LODOP, proxy, PRINT_TYPE.ATTACHMENT);
}
